/* eslint-disable */
import { DocumentNode } from 'graphql';
import * as Urql from '@urql/vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  EmailAddress: { input: string; output: string; }
  JSON: { input: string; output: string; }
  RepeaterInstance: { input: any; output: any; }
  URL: { input: string; output: string; }
};

/**
 * Definition of AboutPage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type AboutPage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for AboutPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<AboutPageVariants>;
  /** undefined */
  clientsList?: Maybe<Array<Maybe<Company>>>;
  /** undefined */
  clientsTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroBackground?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  heroModel3D?: Maybe<MediaFile>;
  /** undefined */
  heroPreTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroVideoOverlayLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** Discover More */
  pressCtaLabel?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be <=5
   */
  pressQuotes?: Maybe<Array<Maybe<Scalars['RepeaterInstance']['output']>>>;
  /** undefined */
  pressTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** undefined */
  whatWeDoCategories?: Maybe<Array<Maybe<WorkCategory>>>;
  /** undefined */
  whatWeDoDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  whatWeDoTitle?: Maybe<Scalars['String']['output']>;
};


/**
 * Definition of AboutPage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type AboutPageClientsListArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};


/**
 * Definition of AboutPage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type AboutPagePressQuotesArgs = {
  referenceContentPassword?: InputMaybe<Scalars['String']['input']>;
  referenceResolutionStrategy?: InputMaybe<RepeaterReferenceResolutionStrategy>;
};


/**
 * Definition of AboutPage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type AboutPageWhatWeDoCategoriesArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorkCategoryVariantSelection>>>;
};

/** Input fields necessary to Create a AboutPage */
export type AboutPageCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for AboutPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<AboutPageVariantsInput>;
  /** undefined */
  clientsList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  clientsTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroBackground?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  heroModel3D?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroPreTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVideoOverlayLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Discover More */
  pressCtaLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be <=5
   */
  pressQuotes?: InputMaybe<Array<InputMaybe<Scalars['RepeaterInstance']['input']>>>;
  /** undefined */
  pressTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  /** undefined */
  whatWeDoCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  whatWeDoDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoTitle?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to AboutPage. */
export enum AboutPageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering AboutPage. */
export type AboutPageFilterOptions = {
  field?: InputMaybe<AboutPageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort AboutPage */
export enum AboutPageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a AboutPage */
export type AboutPageUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for AboutPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<AboutPageVariantsInput>;
  /** undefined */
  clientsList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  clientsTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroBackground?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  heroModel3D?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroPreTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVideoOverlayLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Discover More */
  pressCtaLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be <=5
   */
  pressQuotes?: InputMaybe<Array<InputMaybe<Scalars['RepeaterInstance']['input']>>>;
  /** undefined */
  pressTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  whatWeDoDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoTitle?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for AboutPage */
export type AboutPageVariant = {
  /** undefined */
  clientsList?: Maybe<Array<Maybe<Company>>>;
  /** undefined */
  clientsTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroBackground?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  heroModel3D?: Maybe<MediaFile>;
  /** undefined */
  heroPreTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroVideoOverlayLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Discover More */
  pressCtaLabel?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be <=5
   */
  pressQuotes?: Maybe<Array<Maybe<Scalars['RepeaterInstance']['output']>>>;
  /** undefined */
  pressTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** undefined */
  whatWeDoCategories?: Maybe<Array<Maybe<WorkCategory>>>;
  /** undefined */
  whatWeDoDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  whatWeDoTitle?: Maybe<Scalars['String']['output']>;
};


/** Definition of a possible variant for AboutPage */
export type AboutPageVariantClientsListArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};


/** Definition of a possible variant for AboutPage */
export type AboutPageVariantPressQuotesArgs = {
  referenceContentPassword?: InputMaybe<Scalars['String']['input']>;
  referenceResolutionStrategy?: InputMaybe<RepeaterReferenceResolutionStrategy>;
};


/** Definition of a possible variant for AboutPage */
export type AboutPageVariantWhatWeDoCategoriesArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorkCategoryVariantSelection>>>;
};

/** Definition of the input for a possible variant for AboutPage */
export type AboutPageVariantInput = {
  /** undefined */
  clientsList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  clientsTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroBackground?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  heroModel3D?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroPreTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVideoOverlayLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Discover More */
  pressCtaLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be <=5
   */
  pressQuotes?: InputMaybe<Array<InputMaybe<Scalars['RepeaterInstance']['input']>>>;
  /** undefined */
  pressTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  whatWeDoDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoTitle?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for AboutPage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum AboutPageVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for AboutPage with their name as key. */
export type AboutPageVariants = {
  /** A variant fr for AboutPage */
  fr?: Maybe<AboutPageVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for AboutPage */
  it?: Maybe<AboutPageVariant>;
};

/** Input fields necessary to Create or Update a Variants for AboutPage */
export type AboutPageVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for AboutPage */
  fr?: InputMaybe<AboutPageVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for AboutPage */
  it?: InputMaybe<AboutPageVariantInput>;
};

/** Possible ways to request AboutPage in a Get query using the where parameter */
export enum AboutPageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type AboutPageWhereParameter = {
  field?: InputMaybe<AboutPageWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of AwardAuthority as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type AwardAuthority = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for AwardAuthority.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<AwardAuthorityVariants>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /**
   * undefined
   * Value must be image/svg+xml
   */
  logo?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  model?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  /** undefined */
  website?: Maybe<Scalars['URL']['output']>;
};

/** Input fields necessary to Create a AwardAuthority */
export type AwardAuthorityCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for AwardAuthority.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<AwardAuthorityVariantsInput>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/svg+xml
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** undefined */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to AwardAuthority. */
export enum AwardAuthorityFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering AwardAuthority. */
export type AwardAuthorityFilterOptions = {
  field?: InputMaybe<AwardAuthorityFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort AwardAuthority */
export enum AwardAuthoritySortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a AwardAuthority */
export type AwardAuthorityUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for AwardAuthority.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<AwardAuthorityVariantsInput>;
  /**
   * undefined
   *
   * Value must be image/svg+xml
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for AwardAuthority */
export type AwardAuthorityVariant = {
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * undefined
   * Value must be image/svg+xml
   */
  logo?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  model?: Maybe<MediaFile>;
  name?: Maybe<Scalars['String']['output']>;
  /** undefined */
  website?: Maybe<Scalars['URL']['output']>;
};

/** Definition of the input for a possible variant for AwardAuthority */
export type AwardAuthorityVariantInput = {
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * undefined
   *
   * Value must be image/svg+xml
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  website?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for AwardAuthority.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum AwardAuthorityVariantSelection {
  Base = 'base'
}

/** All variants for AwardAuthority with their name as key. */
export type AwardAuthorityVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for AwardAuthority */
export type AwardAuthorityVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request AwardAuthority in a Get query using the where parameter */
export enum AwardAuthorityWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type AwardAuthorityWhereParameter = {
  field?: InputMaybe<AwardAuthorityWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of CollabHubPage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type CollabHubPage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for CollabHubPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<CollabHubPageVariants>;
  /** undefined */
  contents?: Maybe<Array<Maybe<CollabHubPageContentsItem>>>;
  /** undefined */
  formSuccessTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formThanksDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formThanksTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formTitle?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CollabHubPageContentsItem = ContentList | ContentText;

export type CollabHubPageContentsItemCreateInput = {
  list?: InputMaybe<ContentListCreateInput>;
  text?: InputMaybe<ContentTextCreateInput>;
};

export type CollabHubPageContentsItemUpdateInput = {
  list?: InputMaybe<ContentListCreateInput>;
  text?: InputMaybe<ContentTextCreateInput>;
};

/** Input fields necessary to Create a CollabHubPage */
export type CollabHubPageCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for CollabHubPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<CollabHubPageVariantsInput>;
  /** undefined */
  contents?: InputMaybe<Array<InputMaybe<CollabHubPageContentsItemCreateInput>>>;
  /** undefined */
  formSuccessTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formThanksDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formThanksTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to CollabHubPage. */
export enum CollabHubPageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering CollabHubPage. */
export type CollabHubPageFilterOptions = {
  field?: InputMaybe<CollabHubPageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort CollabHubPage */
export enum CollabHubPageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a CollabHubPage */
export type CollabHubPageUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for CollabHubPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<CollabHubPageVariantsInput>;
  /** undefined */
  contents?: InputMaybe<Array<InputMaybe<CollabHubPageContentsItemUpdateInput>>>;
  /** undefined */
  formSuccessTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formThanksDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formThanksTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for CollabHubPage */
export type CollabHubPageVariant = {
  /** undefined */
  contents?: Maybe<Array<Maybe<CollabHubPageVariantContentsItem>>>;
  /** undefined */
  formSuccessTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formThanksDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formThanksTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formTitle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CollabHubPageVariantContentsItem = ContentList | ContentText;

export type CollabHubPageVariantContentsItemCreateInput = {
  list?: InputMaybe<ContentListCreateInput>;
  text?: InputMaybe<ContentTextCreateInput>;
};

export type CollabHubPageVariantContentsItemUpdateInput = {
  list?: InputMaybe<ContentListCreateInput>;
  text?: InputMaybe<ContentTextCreateInput>;
};

/** Definition of the input for a possible variant for CollabHubPage */
export type CollabHubPageVariantInput = {
  /** undefined */
  contents?: InputMaybe<Array<InputMaybe<CollabHubPageVariantContentsItemUpdateInput>>>;
  /** undefined */
  formSuccessTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formThanksDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formThanksTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formTitle?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for CollabHubPage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum CollabHubPageVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for CollabHubPage with their name as key. */
export type CollabHubPageVariants = {
  /** A variant fr for CollabHubPage */
  fr?: Maybe<CollabHubPageVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for CollabHubPage */
  it?: Maybe<CollabHubPageVariant>;
};

/** Input fields necessary to Create or Update a Variants for CollabHubPage */
export type CollabHubPageVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for CollabHubPage */
  fr?: InputMaybe<CollabHubPageVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for CollabHubPage */
  it?: InputMaybe<CollabHubPageVariantInput>;
};

/** Possible ways to request CollabHubPage in a Get query using the where parameter */
export enum CollabHubPageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type CollabHubPageWhereParameter = {
  field?: InputMaybe<CollabHubPageWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of Company as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type Company = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for Company.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<CompanyVariants>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /**
   * undefined
   * Value must be image/*
   */
  logo?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  /** undefined */
  website?: Maybe<Scalars['URL']['output']>;
};

/** Input fields necessary to Create a Company */
export type CompanyCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Company.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<CompanyVariantsInput>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** undefined */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to Company. */
export enum CompanyFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering Company. */
export type CompanyFilterOptions = {
  field?: InputMaybe<CompanyFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort Company */
export enum CompanySortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a Company */
export type CompanyUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Company.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<CompanyVariantsInput>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for Company */
export type CompanyVariant = {
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  logo?: Maybe<MediaFile>;
  name?: Maybe<Scalars['String']['output']>;
  /** undefined */
  website?: Maybe<Scalars['URL']['output']>;
};

/** Definition of the input for a possible variant for Company */
export type CompanyVariantInput = {
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  website?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for Company.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum CompanyVariantSelection {
  Base = 'base'
}

/** All variants for Company with their name as key. */
export type CompanyVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for Company */
export type CompanyVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request Company in a Get query using the where parameter */
export enum CompanyWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type CompanyWhereParameter = {
  field?: InputMaybe<CompanyWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of ContactPage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type ContactPage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for ContactPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<ContactPageVariants>;
  /** undefined */
  formGeneralTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formInternationalOpportunitiesTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formJobsTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formMarketingTitle?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  introPreTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introTitle?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  model3d?: Maybe<MediaFile>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Input fields necessary to Create a ContactPage */
export type ContactPageCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for ContactPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<ContactPageVariantsInput>;
  /** undefined */
  formGeneralTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formInternationalOpportunitiesTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formJobsTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formMarketingTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introPreTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  model3d?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to ContactPage. */
export enum ContactPageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering ContactPage. */
export type ContactPageFilterOptions = {
  field?: InputMaybe<ContactPageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort ContactPage */
export enum ContactPageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a ContactPage */
export type ContactPageUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for ContactPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<ContactPageVariantsInput>;
  /** undefined */
  formGeneralTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formInternationalOpportunitiesTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formJobsTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formMarketingTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introPreTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  model3d?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for ContactPage */
export type ContactPageVariant = {
  /** undefined */
  formGeneralTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formInternationalOpportunitiesTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formJobsTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  formMarketingTitle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  introPreTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introTitle?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  model3d?: Maybe<MediaFile>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for ContactPage */
export type ContactPageVariantInput = {
  /** undefined */
  formGeneralTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formInternationalOpportunitiesTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formJobsTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  formMarketingTitle?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  introPreTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  model3d?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for ContactPage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum ContactPageVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for ContactPage with their name as key. */
export type ContactPageVariants = {
  /** A variant fr for ContactPage */
  fr?: Maybe<ContactPageVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for ContactPage */
  it?: Maybe<ContactPageVariant>;
};

/** Input fields necessary to Create or Update a Variants for ContactPage */
export type ContactPageVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for ContactPage */
  fr?: InputMaybe<ContactPageVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for ContactPage */
  it?: InputMaybe<ContactPageVariantInput>;
};

/** Possible ways to request ContactPage in a Get query using the where parameter */
export enum ContactPageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type ContactPageWhereParameter = {
  field?: InputMaybe<ContactPageWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of ContentList as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: PUBLIC
 * Delete: PUBLIC
 * Update: PUBLIC
 * Get DRAFT: PUBLIC
 * Get PUBLISHED: PUBLIC
 * List DRAFT: PUBLIC
 * List PUBLISHED: PUBLIC
 * Publish: PUBLIC
 * Unpublish: PUBLIC
 */
export type ContentList = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  list?: Maybe<Array<Maybe<ContentListItem>>>;
  /** undefined */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input fields necessary to Create a ContentList */
export type ContentListCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  list?: InputMaybe<Array<InputMaybe<ContentListItemCreateInput>>>;
  /** undefined */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Definition of ContentListItem as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: PUBLIC
 * Delete: PUBLIC
 * Update: PUBLIC
 * Get DRAFT: PUBLIC
 * Get PUBLISHED: PUBLIC
 * List DRAFT: PUBLIC
 * List PUBLISHED: PUBLIC
 * Publish: PUBLIC
 * Unpublish: PUBLIC
 */
export type ContentListItem = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  text?: Maybe<Scalars['String']['output']>;
  /** undefined */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input fields necessary to Create a ContentListItem */
export type ContentListItemCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  text?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input fields necessary to Update a ContentListItem */
export type ContentListItemUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  text?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentListItemVariantSelection {
  Base = 'base'
}

/** Input fields necessary to Update a ContentList */
export type ContentListUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  list?: InputMaybe<Array<InputMaybe<ContentListItemUpdateInput>>>;
  /** undefined */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentListVariantSelection {
  Base = 'base'
}

export enum ContentStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/**
 * Definition of ContentText as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: PUBLIC
 * Delete: PUBLIC
 * Update: PUBLIC
 * Get DRAFT: PUBLIC
 * Get PUBLISHED: PUBLIC
 * List DRAFT: PUBLIC
 * List PUBLISHED: PUBLIC
 * Publish: PUBLIC
 * Unpublish: PUBLIC
 */
export type ContentText = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /** undefined */
  author?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  layout?: Maybe<Scalars['String']['output']>;
  /** undefined */
  text: Scalars['String']['output'];
  /** undefined */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input fields necessary to Create a ContentText */
export type ContentTextCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  author?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  layout?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  text: Scalars['String']['input'];
  /** undefined */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input fields necessary to Update a ContentText */
export type ContentTextUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  author?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  layout?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  text?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentTextVariantSelection {
  Base = 'base'
}

export enum FilterOperator {
  BeginsWith = 'beginsWith',
  Between = 'between',
  Eq = 'eq',
  Ge = 'ge',
  Gt = 'gt',
  Le = 'le',
  Lt = 'lt'
}

/**
 * Definition of HomePage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type HomePage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for HomePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<HomePageVariants>;
  /** undefined */
  aboutUsBackground?: Maybe<MediaFile>;
  /** About Us */
  aboutUsCtaLabel?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  aboutUsGlb?: Maybe<MediaFile>;
  /** undefined */
  aboutUsPreText1?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsPreText2?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsPreText3?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsText1?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsText2?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsText3?: Maybe<Scalars['String']['output']>;
  /** undefined */
  featuredWorksList?: Maybe<Array<Maybe<Project>>>;
  /** undefined */
  featuredWorksTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroText?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be undefinedvideo/*
   */
  heroVideo?: Maybe<MediaFile>;
  /** undefined */
  heroVideoOverlayLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  ourOfficesList?: Maybe<Array<Maybe<Office>>>;
  /**
   * undefined
   * Value must be ==5
   */
  ourOfficesMedia?: Maybe<Array<Maybe<MediaFile>>>;
  /** undefined */
  ourOfficesTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** undefined */
  whatWeDoIntroText?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be undefinedvideo/*
   */
  whatWeDoVideo?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be video/*
   */
  whatWeDoVideoMobile?: Maybe<MediaFile>;
  /** undefined */
  whatWeDoVideoOverlayLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/**
 * Definition of HomePage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type HomePageFeaturedWorksListArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProjectVariantSelection>>>;
};


/**
 * Definition of HomePage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type HomePageOurOfficesListArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<OfficeVariantSelection>>>;
};

/** Input fields necessary to Create a HomePage */
export type HomePageCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for HomePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<HomePageVariantsInput>;
  /** undefined */
  aboutUsBackground?: InputMaybe<Scalars['String']['input']>;
  /** About Us */
  aboutUsCtaLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  aboutUsGlb?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsPreText1?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsPreText2?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsPreText3?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsText1?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsText2?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsText3?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  featuredWorksList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  featuredWorksTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroText?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be undefinedvideo/*
   */
  heroVideo?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVideoOverlayLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  ourOfficesList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * undefined
   *
   * Value must be ==5
   */
  ourOfficesMedia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  ourOfficesTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  /** undefined */
  whatWeDoIntroText?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be undefinedvideo/*
   */
  whatWeDoVideo?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be video/*
   */
  whatWeDoVideoMobile?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoVideoOverlayLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Possible fields where a filter can be applied to HomePage. */
export enum HomePageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering HomePage. */
export type HomePageFilterOptions = {
  field?: InputMaybe<HomePageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort HomePage */
export enum HomePageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a HomePage */
export type HomePageUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for HomePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<HomePageVariantsInput>;
  /** undefined */
  aboutUsBackground?: InputMaybe<Scalars['String']['input']>;
  /** About Us */
  aboutUsCtaLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  aboutUsGlb?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsPreText1?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsPreText2?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsPreText3?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsText1?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsText2?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsText3?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  featuredWorksList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  featuredWorksTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroText?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be undefinedvideo/*
   */
  heroVideo?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVideoOverlayLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  ourOfficesList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * undefined
   *
   * Value must be ==5
   */
  ourOfficesMedia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  ourOfficesTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoIntroText?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be undefinedvideo/*
   */
  whatWeDoVideo?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be video/*
   */
  whatWeDoVideoMobile?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoVideoOverlayLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Definition of a possible variant for HomePage */
export type HomePageVariant = {
  /** undefined */
  aboutUsBackground?: Maybe<MediaFile>;
  /** About Us */
  aboutUsCtaLabel?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  aboutUsGlb?: Maybe<MediaFile>;
  /** undefined */
  aboutUsPreText1?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsPreText2?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsPreText3?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsText1?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsText2?: Maybe<Scalars['String']['output']>;
  /** undefined */
  aboutUsText3?: Maybe<Scalars['String']['output']>;
  /** undefined */
  featuredWorksList?: Maybe<Array<Maybe<Project>>>;
  /** undefined */
  featuredWorksTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroText?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be undefinedvideo/*
   */
  heroVideo?: Maybe<MediaFile>;
  /** undefined */
  heroVideoOverlayLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  ourOfficesList?: Maybe<Array<Maybe<Office>>>;
  /**
   * undefined
   * Value must be ==5
   */
  ourOfficesMedia?: Maybe<Array<Maybe<MediaFile>>>;
  /** undefined */
  ourOfficesTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** undefined */
  whatWeDoIntroText?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be undefinedvideo/*
   */
  whatWeDoVideo?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be video/*
   */
  whatWeDoVideoMobile?: Maybe<MediaFile>;
  /** undefined */
  whatWeDoVideoOverlayLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** Definition of a possible variant for HomePage */
export type HomePageVariantFeaturedWorksListArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProjectVariantSelection>>>;
};


/** Definition of a possible variant for HomePage */
export type HomePageVariantOurOfficesListArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<OfficeVariantSelection>>>;
};

/** Definition of the input for a possible variant for HomePage */
export type HomePageVariantInput = {
  /** undefined */
  aboutUsBackground?: InputMaybe<Scalars['String']['input']>;
  /** About Us */
  aboutUsCtaLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  aboutUsGlb?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsPreText1?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsPreText2?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsPreText3?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsText1?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsText2?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  aboutUsText3?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  featuredWorksList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  featuredWorksTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroText?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be undefinedvideo/*
   */
  heroVideo?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVideoOverlayLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  ourOfficesList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * undefined
   *
   * Value must be ==5
   */
  ourOfficesMedia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  ourOfficesTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoIntroText?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be undefinedvideo/*
   */
  whatWeDoVideo?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be video/*
   */
  whatWeDoVideoMobile?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  whatWeDoVideoOverlayLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Possible fields variants for HomePage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum HomePageVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for HomePage with their name as key. */
export type HomePageVariants = {
  /** A variant fr for HomePage */
  fr?: Maybe<HomePageVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for HomePage */
  it?: Maybe<HomePageVariant>;
};

/** Input fields necessary to Create or Update a Variants for HomePage */
export type HomePageVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for HomePage */
  fr?: InputMaybe<HomePageVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for HomePage */
  it?: InputMaybe<HomePageVariantInput>;
};

/** Possible ways to request HomePage in a Get query using the where parameter */
export enum HomePageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type HomePageWhereParameter = {
  field?: InputMaybe<HomePageWhereOptions>;
  value: Scalars['String']['input'];
};

/** List result of a AboutPage list. */
export type ListAboutPageResult = {
  /** Cursor, pass this as parameter to ListAboutPage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of AboutPage items */
  items: Array<Maybe<AboutPage>>;
  /** Total count of type AboutPage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a AwardAuthority list. */
export type ListAwardAuthorityResult = {
  /** Cursor, pass this as parameter to ListAwardAuthority in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of AwardAuthority items */
  items: Array<Maybe<AwardAuthority>>;
  /** Total count of type AwardAuthority in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a CollabHubPage list. */
export type ListCollabHubPageResult = {
  /** Cursor, pass this as parameter to ListCollabHubPage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of CollabHubPage items */
  items: Array<Maybe<CollabHubPage>>;
  /** Total count of type CollabHubPage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a Company list. */
export type ListCompanyResult = {
  /** Cursor, pass this as parameter to ListCompany in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of Company items */
  items: Array<Maybe<Company>>;
  /** Total count of type Company in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a ContactPage list. */
export type ListContactPageResult = {
  /** Cursor, pass this as parameter to ListContactPage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of ContactPage items */
  items: Array<Maybe<ContactPage>>;
  /** Total count of type ContactPage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a HomePage list. */
export type ListHomePageResult = {
  /** Cursor, pass this as parameter to ListHomePage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of HomePage items */
  items: Array<Maybe<HomePage>>;
  /** Total count of type HomePage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a MediaFile list. */
export type ListMediaFileResult = {
  /** Cursor, pass this as parameter to ListMediaFile in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of MediaFile items */
  items: Array<Maybe<MediaFile>>;
  /** Total count of type MediaFile in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a NewsletterPage list. */
export type ListNewsletterPageResult = {
  /** Cursor, pass this as parameter to ListNewsletterPage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of NewsletterPage items */
  items: Array<Maybe<NewsletterPage>>;
  /** Total count of type NewsletterPage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a Office list. */
export type ListOfficeResult = {
  /** Cursor, pass this as parameter to ListOffice in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of Office items */
  items: Array<Maybe<Office>>;
  /** Total count of type Office in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a Person list. */
export type ListPersonResult = {
  /** Cursor, pass this as parameter to ListPerson in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of Person items */
  items: Array<Maybe<Person>>;
  /** Total count of type Person in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a Platform list. */
export type ListPlatformResult = {
  /** Cursor, pass this as parameter to ListPlatform in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of Platform items */
  items: Array<Maybe<Platform>>;
  /** Total count of type Platform in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a PressArticle list. */
export type ListPressArticleResult = {
  /** Cursor, pass this as parameter to ListPressArticle in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of PressArticle items */
  items: Array<Maybe<PressArticle>>;
  /** Total count of type PressArticle in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a PressPage list. */
export type ListPressPageResult = {
  /** Cursor, pass this as parameter to ListPressPage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of PressPage items */
  items: Array<Maybe<PressPage>>;
  /** Total count of type PressPage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a Project list. */
export type ListProjectResult = {
  /** Cursor, pass this as parameter to ListProject in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of Project items */
  items: Array<Maybe<Project>>;
  /** Total count of type Project in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a PrototypeCategory list. */
export type ListPrototypeCategoryResult = {
  /** Cursor, pass this as parameter to ListPrototypeCategory in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of PrototypeCategory items */
  items: Array<Maybe<PrototypeCategory>>;
  /** Total count of type PrototypeCategory in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a PrototypePage list. */
export type ListPrototypePageResult = {
  /** Cursor, pass this as parameter to ListPrototypePage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of PrototypePage items */
  items: Array<Maybe<PrototypePage>>;
  /** Total count of type PrototypePage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a Prototype list. */
export type ListPrototypeResult = {
  /** Cursor, pass this as parameter to ListPrototype in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of Prototype items */
  items: Array<Maybe<Prototype>>;
  /** Total count of type Prototype in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a Settings list. */
export type ListSettingsResult = {
  /** Cursor, pass this as parameter to ListSettings in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of Settings items */
  items: Array<Maybe<Settings>>;
  /** Total count of type Settings in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a UniversePage list. */
export type ListUniversePageResult = {
  /** Cursor, pass this as parameter to ListUniversePage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of UniversePage items */
  items: Array<Maybe<UniversePage>>;
  /** Total count of type UniversePage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a User list. */
export type ListUserResult = {
  /** Cursor, pass this as parameter to ListUser in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of User items */
  items: Array<Maybe<User>>;
  /** Total count of type User in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a WorkCategory list. */
export type ListWorkCategoryResult = {
  /** Cursor, pass this as parameter to ListWorkCategory in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of WorkCategory items */
  items: Array<Maybe<WorkCategory>>;
  /** Total count of type WorkCategory in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a WorksPage list. */
export type ListWorksPageResult = {
  /** Cursor, pass this as parameter to ListWorksPage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of WorksPage items */
  items: Array<Maybe<WorksPage>>;
  /** Total count of type WorksPage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Definition of MediaFile as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: NOONE
 * Get DRAFT: NOONE
 * Get PUBLISHED: PUBLIC
 * List DRAFT: NOONE
 * List PUBLISHED: PUBLIC
 * Publish: NOONE
 * Unpublish: NOONE
 */
export type MediaFile = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for MediaFile.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<MediaFileVariants>;
  fileSize: Scalars['Float']['output'];
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  mimeType: Scalars['String']['output'];
  optimized?: Maybe<Scalars['JSON']['output']>;
  /** example.jpg */
  originalName: Scalars['String']['output'];
  /**
   * An object containing information for how to upload the image using a multipart post upload.
   * Requester must have appropriate MediaFile create access level
   */
  uploadSignedRequest?: Maybe<Scalars['JSON']['output']>;
};

/** Input fields necessary to Create a MediaFile */
export type MediaFileCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for MediaFile.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<MediaFileVariantsInput>;
  fileSize: Scalars['Float']['input'];
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  optimized?: InputMaybe<Scalars['String']['input']>;
  /** example.jpg */
  originalName: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to MediaFile. */
export enum MediaFileFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  FileSize = 'fileSize',
  Id = 'id',
  MimeType = 'mimeType'
}

/** Options for filtering MediaFile. */
export type MediaFileFilterOptions = {
  field?: InputMaybe<MediaFileFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort MediaFile */
export enum MediaFileSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  FileSize = 'fileSize',
  Id = 'id',
  MimeType = 'mimeType'
}

/** Input fields necessary to Update a MediaFile */
export type MediaFileUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for MediaFile.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<MediaFileVariantsInput>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  optimized?: InputMaybe<Scalars['String']['input']>;
  /** example.jpg */
  originalName?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for MediaFile */
export type MediaFileVariant = {
  fileSize?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  optimized?: Maybe<Scalars['JSON']['output']>;
  /** example.jpg */
  originalName?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for MediaFile */
export type MediaFileVariantInput = {
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  optimized?: InputMaybe<Scalars['String']['input']>;
  /** example.jpg */
  originalName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for MediaFile.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum MediaFileVariantSelection {
  Base = 'base'
}

/** All variants for MediaFile with their name as key. */
export type MediaFileVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for MediaFile */
export type MediaFileVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request MediaFile in a Get query using the where parameter */
export enum MediaFileWhereOptions {
  ModifiedAt = '_modifiedAt',
  FileSize = 'fileSize',
  MimeType = 'mimeType'
}

export type MediaFileWhereParameter = {
  field?: InputMaybe<MediaFileWhereOptions>;
  value: Scalars['String']['input'];
};

export type Mutation = {
  /**
   * Creates a new AboutPage.
   *
   * Status of the content will be set to DRAFT
   */
  CreateAboutPage?: Maybe<AboutPage>;
  /**
   * Creates a new AwardAuthority.
   *
   * Status of the content will be set to DRAFT
   */
  CreateAwardAuthority?: Maybe<AwardAuthority>;
  /**
   * Creates a new CollabHubPage.
   *
   * Status of the content will be set to DRAFT
   */
  CreateCollabHubPage?: Maybe<CollabHubPage>;
  /**
   * Creates a new Company.
   *
   * Status of the content will be set to DRAFT
   */
  CreateCompany?: Maybe<Company>;
  /**
   * Creates a new ContactPage.
   *
   * Status of the content will be set to DRAFT
   */
  CreateContactPage?: Maybe<ContactPage>;
  /**
   * Creates a new HomePage.
   *
   * Status of the content will be set to DRAFT
   */
  CreateHomePage?: Maybe<HomePage>;
  /**
   * Creates a new MediaFile.
   *
   * Status of the content will be set to DRAFT
   */
  CreateMediaFile?: Maybe<MediaFile>;
  /**
   * Creates a new NewsletterPage.
   *
   * Status of the content will be set to DRAFT
   */
  CreateNewsletterPage?: Maybe<NewsletterPage>;
  /**
   * Creates a new Office.
   *
   * Status of the content will be set to DRAFT
   */
  CreateOffice?: Maybe<Office>;
  /**
   * Creates a new Person.
   *
   * Status of the content will be set to DRAFT
   */
  CreatePerson?: Maybe<Person>;
  /**
   * Creates a new Platform.
   *
   * Status of the content will be set to DRAFT
   */
  CreatePlatform?: Maybe<Platform>;
  /**
   * Creates a new PressArticle.
   *
   * Status of the content will be set to DRAFT
   */
  CreatePressArticle?: Maybe<PressArticle>;
  /**
   * Creates a new PressPage.
   *
   * Status of the content will be set to DRAFT
   */
  CreatePressPage?: Maybe<PressPage>;
  /**
   * Creates a new Project.
   *
   * Status of the content will be set to DRAFT
   */
  CreateProject?: Maybe<Project>;
  /**
   * Creates a new Prototype.
   *
   * Status of the content will be set to DRAFT
   */
  CreatePrototype?: Maybe<Prototype>;
  /**
   * Creates a new PrototypeCategory.
   *
   * Status of the content will be set to DRAFT
   */
  CreatePrototypeCategory?: Maybe<PrototypeCategory>;
  /**
   * Creates a new PrototypePage.
   *
   * Status of the content will be set to DRAFT
   */
  CreatePrototypePage?: Maybe<PrototypePage>;
  /**
   * Creates a new Settings.
   *
   * Status of the content will be set to DRAFT
   */
  CreateSettings?: Maybe<Settings>;
  /**
   * Creates a new UniversePage.
   *
   * Status of the content will be set to DRAFT
   */
  CreateUniversePage?: Maybe<UniversePage>;
  /**
   * Creates a new User.
   *
   * Status of the content will be set to DRAFT
   */
  CreateUser?: Maybe<User>;
  /**
   * Creates a new WorkCategory.
   *
   * Status of the content will be set to DRAFT
   */
  CreateWorkCategory?: Maybe<WorkCategory>;
  /**
   * Creates a new WorksPage.
   *
   * Status of the content will be set to DRAFT
   */
  CreateWorksPage?: Maybe<WorksPage>;
  /** Deletes a AboutPage. */
  DeleteAboutPage?: Maybe<AboutPage>;
  /** Deletes a AwardAuthority. */
  DeleteAwardAuthority?: Maybe<AwardAuthority>;
  /** Deletes a CollabHubPage. */
  DeleteCollabHubPage?: Maybe<CollabHubPage>;
  /** Deletes a Company. */
  DeleteCompany?: Maybe<Company>;
  /** Deletes a ContactPage. */
  DeleteContactPage?: Maybe<ContactPage>;
  /** Deletes a HomePage. */
  DeleteHomePage?: Maybe<HomePage>;
  /** Deletes a MediaFile. */
  DeleteMediaFile?: Maybe<MediaFile>;
  /** Deletes a NewsletterPage. */
  DeleteNewsletterPage?: Maybe<NewsletterPage>;
  /** Deletes a Office. */
  DeleteOffice?: Maybe<Office>;
  /** Deletes a Person. */
  DeletePerson?: Maybe<Person>;
  /** Deletes a Platform. */
  DeletePlatform?: Maybe<Platform>;
  /** Deletes a PressArticle. */
  DeletePressArticle?: Maybe<PressArticle>;
  /** Deletes a PressPage. */
  DeletePressPage?: Maybe<PressPage>;
  /** Deletes a Project. */
  DeleteProject?: Maybe<Project>;
  /** Deletes a Prototype. */
  DeletePrototype?: Maybe<Prototype>;
  /** Deletes a PrototypeCategory. */
  DeletePrototypeCategory?: Maybe<PrototypeCategory>;
  /** Deletes a PrototypePage. */
  DeletePrototypePage?: Maybe<PrototypePage>;
  /** Deletes a Settings. */
  DeleteSettings?: Maybe<Settings>;
  /** Deletes a UniversePage. */
  DeleteUniversePage?: Maybe<UniversePage>;
  /** Deletes a User. */
  DeleteUser?: Maybe<User>;
  /** Deletes a WorkCategory. */
  DeleteWorkCategory?: Maybe<WorkCategory>;
  /** Deletes a WorksPage. */
  DeleteWorksPage?: Maybe<WorksPage>;
  /** Publishes a AboutPage. */
  PublishAboutPage?: Maybe<AboutPage>;
  /** Publishes a AwardAuthority. */
  PublishAwardAuthority?: Maybe<AwardAuthority>;
  /** Publishes a CollabHubPage. */
  PublishCollabHubPage?: Maybe<CollabHubPage>;
  /** Publishes a Company. */
  PublishCompany?: Maybe<Company>;
  /** Publishes a ContactPage. */
  PublishContactPage?: Maybe<ContactPage>;
  /** Publishes a HomePage. */
  PublishHomePage?: Maybe<HomePage>;
  /** Publishes a NewsletterPage. */
  PublishNewsletterPage?: Maybe<NewsletterPage>;
  /** Publishes a Office. */
  PublishOffice?: Maybe<Office>;
  /** Publishes a Person. */
  PublishPerson?: Maybe<Person>;
  /** Publishes a Platform. */
  PublishPlatform?: Maybe<Platform>;
  /** Publishes a PressArticle. */
  PublishPressArticle?: Maybe<PressArticle>;
  /** Publishes a PressPage. */
  PublishPressPage?: Maybe<PressPage>;
  /** Publishes a Project. */
  PublishProject?: Maybe<Project>;
  /** Publishes a Prototype. */
  PublishPrototype?: Maybe<Prototype>;
  /** Publishes a PrototypeCategory. */
  PublishPrototypeCategory?: Maybe<PrototypeCategory>;
  /** Publishes a PrototypePage. */
  PublishPrototypePage?: Maybe<PrototypePage>;
  /** Publishes a Settings. */
  PublishSettings?: Maybe<Settings>;
  /** Publishes a UniversePage. */
  PublishUniversePage?: Maybe<UniversePage>;
  /** Publishes a WorkCategory. */
  PublishWorkCategory?: Maybe<WorkCategory>;
  /** Publishes a WorksPage. */
  PublishWorksPage?: Maybe<WorksPage>;
  /** Unpublishes a AboutPage. */
  UnpublishAboutPage?: Maybe<AboutPage>;
  /** Unpublishes a AwardAuthority. */
  UnpublishAwardAuthority?: Maybe<AwardAuthority>;
  /** Unpublishes a CollabHubPage. */
  UnpublishCollabHubPage?: Maybe<CollabHubPage>;
  /** Unpublishes a Company. */
  UnpublishCompany?: Maybe<Company>;
  /** Unpublishes a ContactPage. */
  UnpublishContactPage?: Maybe<ContactPage>;
  /** Unpublishes a HomePage. */
  UnpublishHomePage?: Maybe<HomePage>;
  /** Unpublishes a NewsletterPage. */
  UnpublishNewsletterPage?: Maybe<NewsletterPage>;
  /** Unpublishes a Office. */
  UnpublishOffice?: Maybe<Office>;
  /** Unpublishes a Person. */
  UnpublishPerson?: Maybe<Person>;
  /** Unpublishes a Platform. */
  UnpublishPlatform?: Maybe<Platform>;
  /** Unpublishes a PressArticle. */
  UnpublishPressArticle?: Maybe<PressArticle>;
  /** Unpublishes a PressPage. */
  UnpublishPressPage?: Maybe<PressPage>;
  /** Unpublishes a Project. */
  UnpublishProject?: Maybe<Project>;
  /** Unpublishes a Prototype. */
  UnpublishPrototype?: Maybe<Prototype>;
  /** Unpublishes a PrototypeCategory. */
  UnpublishPrototypeCategory?: Maybe<PrototypeCategory>;
  /** Unpublishes a PrototypePage. */
  UnpublishPrototypePage?: Maybe<PrototypePage>;
  /** Unpublishes a Settings. */
  UnpublishSettings?: Maybe<Settings>;
  /** Unpublishes a UniversePage. */
  UnpublishUniversePage?: Maybe<UniversePage>;
  /** Unpublishes a WorkCategory. */
  UnpublishWorkCategory?: Maybe<WorkCategory>;
  /** Unpublishes a WorksPage. */
  UnpublishWorksPage?: Maybe<WorksPage>;
  /**
   * Updates a AboutPage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateAboutPage?: Maybe<AboutPage>;
  /**
   * Updates a AwardAuthority.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateAwardAuthority?: Maybe<AwardAuthority>;
  /**
   * Updates a CollabHubPage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateCollabHubPage?: Maybe<CollabHubPage>;
  /**
   * Updates a Company.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateCompany?: Maybe<Company>;
  /**
   * Updates a ContactPage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateContactPage?: Maybe<ContactPage>;
  /**
   * Updates a HomePage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateHomePage?: Maybe<HomePage>;
  /**
   * Updates a NewsletterPage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateNewsletterPage?: Maybe<NewsletterPage>;
  /**
   * Updates a Office.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateOffice?: Maybe<Office>;
  /**
   * Updates a Person.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdatePerson?: Maybe<Person>;
  /**
   * Updates a Platform.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdatePlatform?: Maybe<Platform>;
  /**
   * Updates a PressArticle.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdatePressArticle?: Maybe<PressArticle>;
  /**
   * Updates a PressPage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdatePressPage?: Maybe<PressPage>;
  /**
   * Updates a Project.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateProject?: Maybe<Project>;
  /**
   * Updates a Prototype.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdatePrototype?: Maybe<Prototype>;
  /**
   * Updates a PrototypeCategory.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdatePrototypeCategory?: Maybe<PrototypeCategory>;
  /**
   * Updates a PrototypePage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdatePrototypePage?: Maybe<PrototypePage>;
  /**
   * Updates a Settings.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateSettings?: Maybe<Settings>;
  /**
   * Updates a UniversePage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateUniversePage?: Maybe<UniversePage>;
  /**
   * Updates a User.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateUser?: Maybe<User>;
  /**
   * Updates a WorkCategory.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateWorkCategory?: Maybe<WorkCategory>;
  /**
   * Updates a WorksPage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateWorksPage?: Maybe<WorksPage>;
};


export type MutationCreateAboutPageArgs = {
  input: AboutPageCreateInput;
};


export type MutationCreateAwardAuthorityArgs = {
  input: AwardAuthorityCreateInput;
};


export type MutationCreateCollabHubPageArgs = {
  input: CollabHubPageCreateInput;
};


export type MutationCreateCompanyArgs = {
  input: CompanyCreateInput;
};


export type MutationCreateContactPageArgs = {
  input: ContactPageCreateInput;
};


export type MutationCreateHomePageArgs = {
  input: HomePageCreateInput;
};


export type MutationCreateMediaFileArgs = {
  input: MediaFileCreateInput;
};


export type MutationCreateNewsletterPageArgs = {
  input: NewsletterPageCreateInput;
};


export type MutationCreateOfficeArgs = {
  input: OfficeCreateInput;
};


export type MutationCreatePersonArgs = {
  input: PersonCreateInput;
};


export type MutationCreatePlatformArgs = {
  input: PlatformCreateInput;
};


export type MutationCreatePressArticleArgs = {
  input: PressArticleCreateInput;
};


export type MutationCreatePressPageArgs = {
  input: PressPageCreateInput;
};


export type MutationCreateProjectArgs = {
  input: ProjectCreateInput;
};


export type MutationCreatePrototypeArgs = {
  input: PrototypeCreateInput;
};


export type MutationCreatePrototypeCategoryArgs = {
  input: PrototypeCategoryCreateInput;
};


export type MutationCreatePrototypePageArgs = {
  input: PrototypePageCreateInput;
};


export type MutationCreateSettingsArgs = {
  input: SettingsCreateInput;
};


export type MutationCreateUniversePageArgs = {
  input: UniversePageCreateInput;
};


export type MutationCreateUserArgs = {
  input: UserCreateInput;
};


export type MutationCreateWorkCategoryArgs = {
  input: WorkCategoryCreateInput;
};


export type MutationCreateWorksPageArgs = {
  input: WorksPageCreateInput;
};


export type MutationDeleteAboutPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteAwardAuthorityArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCollabHubPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteContactPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteHomePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteMediaFileArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteNewsletterPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteOfficeArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeletePersonArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeletePlatformArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeletePressArticleArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeletePressPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteProjectArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeletePrototypeArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeletePrototypeCategoryArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeletePrototypePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteSettingsArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUniversePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteWorkCategoryArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteWorksPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishAboutPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishAwardAuthorityArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishCollabHubPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishCompanyArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishContactPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishHomePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishNewsletterPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishOfficeArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishPersonArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishPlatformArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishPressArticleArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishPressPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishProjectArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishPrototypeArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishPrototypeCategoryArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishPrototypePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishSettingsArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishUniversePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishWorkCategoryArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishWorksPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishAboutPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishAwardAuthorityArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishCollabHubPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishCompanyArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishContactPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishHomePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishNewsletterPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishOfficeArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishPersonArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishPlatformArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishPressArticleArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishPressPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishProjectArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishPrototypeArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishPrototypeCategoryArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishPrototypePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishSettingsArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishUniversePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishWorkCategoryArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishWorksPageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAboutPageArgs = {
  id: Scalars['String']['input'];
  input: AboutPageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateAwardAuthorityArgs = {
  id: Scalars['String']['input'];
  input: AwardAuthorityUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateCollabHubPageArgs = {
  id: Scalars['String']['input'];
  input: CollabHubPageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['String']['input'];
  input: CompanyUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateContactPageArgs = {
  id: Scalars['String']['input'];
  input: ContactPageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateHomePageArgs = {
  id: Scalars['String']['input'];
  input: HomePageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateNewsletterPageArgs = {
  id: Scalars['String']['input'];
  input: NewsletterPageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateOfficeArgs = {
  id: Scalars['String']['input'];
  input: OfficeUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdatePersonArgs = {
  id: Scalars['String']['input'];
  input: PersonUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdatePlatformArgs = {
  id: Scalars['String']['input'];
  input: PlatformUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdatePressArticleArgs = {
  id: Scalars['String']['input'];
  input: PressArticleUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdatePressPageArgs = {
  id: Scalars['String']['input'];
  input: PressPageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateProjectArgs = {
  id: Scalars['String']['input'];
  input: ProjectUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdatePrototypeArgs = {
  id: Scalars['String']['input'];
  input: PrototypeUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdatePrototypeCategoryArgs = {
  id: Scalars['String']['input'];
  input: PrototypeCategoryUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdatePrototypePageArgs = {
  id: Scalars['String']['input'];
  input: PrototypePageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateSettingsArgs = {
  id: Scalars['String']['input'];
  input: SettingsUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateUniversePageArgs = {
  id: Scalars['String']['input'];
  input: UniversePageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  input: UserUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateWorkCategoryArgs = {
  id: Scalars['String']['input'];
  input: WorkCategoryUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateWorksPageArgs = {
  id: Scalars['String']['input'];
  input: WorksPageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};

/**
 * Definition of NewsletterPage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type NewsletterPage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for NewsletterPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<NewsletterPageVariants>;
  /** undefined */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  model3d?: Maybe<MediaFile>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Input fields necessary to Create a NewsletterPage */
export type NewsletterPageCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for NewsletterPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<NewsletterPageVariantsInput>;
  /** undefined */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  model3d?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to NewsletterPage. */
export enum NewsletterPageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering NewsletterPage. */
export type NewsletterPageFilterOptions = {
  field?: InputMaybe<NewsletterPageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort NewsletterPage */
export enum NewsletterPageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a NewsletterPage */
export type NewsletterPageUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for NewsletterPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<NewsletterPageVariantsInput>;
  /** undefined */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  model3d?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for NewsletterPage */
export type NewsletterPageVariant = {
  /** undefined */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  model3d?: Maybe<MediaFile>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for NewsletterPage */
export type NewsletterPageVariantInput = {
  /** undefined */
  description?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  model3d?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for NewsletterPage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum NewsletterPageVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for NewsletterPage with their name as key. */
export type NewsletterPageVariants = {
  /** A variant fr for NewsletterPage */
  fr?: Maybe<NewsletterPageVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for NewsletterPage */
  it?: Maybe<NewsletterPageVariant>;
};

/** Input fields necessary to Create or Update a Variants for NewsletterPage */
export type NewsletterPageVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for NewsletterPage */
  fr?: InputMaybe<NewsletterPageVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for NewsletterPage */
  it?: InputMaybe<NewsletterPageVariantInput>;
};

/** Possible ways to request NewsletterPage in a Get query using the where parameter */
export enum NewsletterPageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type NewsletterPageWhereParameter = {
  field?: InputMaybe<NewsletterPageWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of Office as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type Office = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for Office.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<OfficeVariants>;
  /** undefined */
  address?: Maybe<Scalars['String']['output']>;
  /** undefined */
  city?: Maybe<Scalars['String']['output']>;
  /** undefined */
  country?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  mail?: Maybe<Scalars['String']['output']>;
  /** undefined */
  phone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Input fields necessary to Create a Office */
export type OfficeCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Office.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<OfficeVariantsInput>;
  /** undefined */
  address?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  city?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  mail?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  phone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to Office. */
export enum OfficeFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering Office. */
export type OfficeFilterOptions = {
  field?: InputMaybe<OfficeFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort Office */
export enum OfficeSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a Office */
export type OfficeUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Office.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<OfficeVariantsInput>;
  /** undefined */
  address?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  city?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  country?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  mail?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for Office */
export type OfficeVariant = {
  /** undefined */
  address?: Maybe<Scalars['String']['output']>;
  /** undefined */
  city?: Maybe<Scalars['String']['output']>;
  /** undefined */
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  mail?: Maybe<Scalars['String']['output']>;
  /** undefined */
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for Office */
export type OfficeVariantInput = {
  /** undefined */
  address?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  city?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  country?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  mail?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for Office.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum OfficeVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for Office with their name as key. */
export type OfficeVariants = {
  /** A variant fr for Office */
  fr?: Maybe<OfficeVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for Office */
  it?: Maybe<OfficeVariant>;
};

/** Input fields necessary to Create or Update a Variants for Office */
export type OfficeVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for Office */
  fr?: InputMaybe<OfficeVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for Office */
  it?: InputMaybe<OfficeVariantInput>;
};

/** Possible ways to request Office in a Get query using the where parameter */
export enum OfficeWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type OfficeWhereParameter = {
  field?: InputMaybe<OfficeWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of Person as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type Person = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for Person.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<PersonVariants>;
  /** undefined */
  employmentType: Scalars['String']['output'];
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** undefined */
  website?: Maybe<Scalars['URL']['output']>;
};

/** Input fields necessary to Create a Person */
export type PersonCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Person.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PersonVariantsInput>;
  /** undefined */
  employmentType: Scalars['String']['input'];
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** undefined */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to Person. */
export enum PersonFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  EmploymentType = 'employmentType',
  Id = 'id'
}

/** Options for filtering Person. */
export type PersonFilterOptions = {
  field?: InputMaybe<PersonFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort Person */
export enum PersonSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  EmploymentType = 'employmentType',
  Id = 'id'
}

/** Input fields necessary to Update a Person */
export type PersonUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Person.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PersonVariantsInput>;
  /** undefined */
  employmentType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for Person */
export type PersonVariant = {
  /** undefined */
  employmentType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** undefined */
  website?: Maybe<Scalars['URL']['output']>;
};

/** Definition of the input for a possible variant for Person */
export type PersonVariantInput = {
  /** undefined */
  employmentType?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  website?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for Person.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum PersonVariantSelection {
  Base = 'base'
}

/** All variants for Person with their name as key. */
export type PersonVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for Person */
export type PersonVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request Person in a Get query using the where parameter */
export enum PersonWhereOptions {
  ModifiedAt = '_modifiedAt',
  EmploymentType = 'employmentType'
}

export type PersonWhereParameter = {
  field?: InputMaybe<PersonWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of Platform as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type Platform = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for Platform.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<PlatformVariants>;
  /**
   * undefined
   * Value must be image/svg+xml
   */
  icon?: Maybe<MediaFile>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Input fields necessary to Create a Platform */
export type PlatformCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Platform.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PlatformVariantsInput>;
  /**
   * undefined
   *
   * Value must be image/svg+xml
   */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to Platform. */
export enum PlatformFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering Platform. */
export type PlatformFilterOptions = {
  field?: InputMaybe<PlatformFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort Platform */
export enum PlatformSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a Platform */
export type PlatformUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Platform.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PlatformVariantsInput>;
  /**
   * undefined
   *
   * Value must be image/svg+xml
   */
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for Platform */
export type PlatformVariant = {
  /**
   * undefined
   * Value must be image/svg+xml
   */
  icon?: Maybe<MediaFile>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for Platform */
export type PlatformVariantInput = {
  /**
   * undefined
   *
   * Value must be image/svg+xml
   */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for Platform.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum PlatformVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for Platform with their name as key. */
export type PlatformVariants = {
  /** A variant fr for Platform */
  fr?: Maybe<PlatformVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for Platform */
  it?: Maybe<PlatformVariant>;
};

/** Input fields necessary to Create or Update a Variants for Platform */
export type PlatformVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for Platform */
  fr?: InputMaybe<PlatformVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for Platform */
  it?: InputMaybe<PlatformVariantInput>;
};

/** Possible ways to request Platform in a Get query using the where parameter */
export enum PlatformWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type PlatformWhereParameter = {
  field?: InputMaybe<PlatformWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of PressArticle as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type PressArticle = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for PressArticle.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<PressArticleVariants>;
  /** undefined */
  date: Scalars['String']['output'];
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /**
   * undefined
   * Value must be image/*
   */
  image?: Maybe<MediaFile>;
  /** undefined */
  source?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** undefined */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Input fields necessary to Create a PressArticle */
export type PressArticleCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for PressArticle.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PressArticleVariantsInput>;
  /** undefined */
  date: Scalars['String']['input'];
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  image?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  source?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to PressArticle. */
export enum PressArticleFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Date = 'date',
  Id = 'id'
}

/** Options for filtering PressArticle. */
export type PressArticleFilterOptions = {
  field?: InputMaybe<PressArticleFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort PressArticle */
export enum PressArticleSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Date = 'date',
  Id = 'id'
}

/** Input fields necessary to Update a PressArticle */
export type PressArticleUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for PressArticle.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PressArticleVariantsInput>;
  /** undefined */
  date?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  image?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  source?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for PressArticle */
export type PressArticleVariant = {
  /** undefined */
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  image?: Maybe<MediaFile>;
  /** undefined */
  source?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** undefined */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Definition of the input for a possible variant for PressArticle */
export type PressArticleVariantInput = {
  /** undefined */
  date?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  image?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  source?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for PressArticle.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum PressArticleVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for PressArticle with their name as key. */
export type PressArticleVariants = {
  /** A variant fr for PressArticle */
  fr?: Maybe<PressArticleVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for PressArticle */
  it?: Maybe<PressArticleVariant>;
};

/** Input fields necessary to Create or Update a Variants for PressArticle */
export type PressArticleVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for PressArticle */
  fr?: InputMaybe<PressArticleVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for PressArticle */
  it?: InputMaybe<PressArticleVariantInput>;
};

/** Possible ways to request PressArticle in a Get query using the where parameter */
export enum PressArticleWhereOptions {
  ModifiedAt = '_modifiedAt',
  Date = 'date'
}

export type PressArticleWhereParameter = {
  field?: InputMaybe<PressArticleWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of PressPage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type PressPage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for PressPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<PressPageVariants>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  pressKit?: Maybe<MediaFile>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Input fields necessary to Create a PressPage */
export type PressPageCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for PressPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PressPageVariantsInput>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  pressKit?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to PressPage. */
export enum PressPageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering PressPage. */
export type PressPageFilterOptions = {
  field?: InputMaybe<PressPageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort PressPage */
export enum PressPageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a PressPage */
export type PressPageUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for PressPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PressPageVariantsInput>;
  /** undefined */
  pressKit?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for PressPage */
export type PressPageVariant = {
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  pressKit?: Maybe<MediaFile>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for PressPage */
export type PressPageVariantInput = {
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  pressKit?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for PressPage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum PressPageVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for PressPage with their name as key. */
export type PressPageVariants = {
  /** A variant fr for PressPage */
  fr?: Maybe<PressPageVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for PressPage */
  it?: Maybe<PressPageVariant>;
};

/** Input fields necessary to Create or Update a Variants for PressPage */
export type PressPageVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for PressPage */
  fr?: InputMaybe<PressPageVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for PressPage */
  it?: InputMaybe<PressPageVariantInput>;
};

/** Possible ways to request PressPage in a Get query using the where parameter */
export enum PressPageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type PressPageWhereParameter = {
  field?: InputMaybe<PressPageWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of Project as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type Project = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** The content password */
  _contentPassword?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for Project.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<ProjectVariants>;
  /** undefined */
  awards?: Maybe<Array<Maybe<ProjectAwardsAward>>>;
  /** undefined */
  brands?: Maybe<Array<Maybe<Company>>>;
  /** undefined */
  categories?: Maybe<Array<Maybe<WorkCategory>>>;
  /** undefined */
  clients?: Maybe<Array<Maybe<Company>>>;
  /** Content of the project, chose from these available elements. */
  content: Array<Maybe<Scalars['RepeaterInstance']['output']>>;
  /** undefined */
  credits?: Maybe<Array<Maybe<ProjectCreditsGroup>>>;
  /** undefined */
  date: Scalars['String']['output'];
  /** undefined */
  deliverables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** undefined */
  excerpt?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  heroImage?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be undefinedvideo/*
   */
  heroVideo?: Maybe<MediaFile>;
  /** undefined */
  heroVideoType?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroVimeoVideoID?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroYoutubeVideoID?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  ogDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  ogImage?: Maybe<MediaFile>;
  /** undefined */
  ogTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  platforms?: Maybe<Array<Maybe<Platform>>>;
  /** undefined */
  techs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
  /** undefined */
  url?: Maybe<Scalars['URL']['output']>;
};


/**
 * Definition of Project as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type ProjectBrandsArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};


/**
 * Definition of Project as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type ProjectCategoriesArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorkCategoryVariantSelection>>>;
};


/**
 * Definition of Project as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type ProjectClientsArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};


/**
 * Definition of Project as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type ProjectContentArgs = {
  referenceContentPassword?: InputMaybe<Scalars['String']['input']>;
  referenceResolutionStrategy?: InputMaybe<RepeaterReferenceResolutionStrategy>;
};


/**
 * Definition of Project as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type ProjectPlatformsArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PlatformVariantSelection>>>;
};

export type ProjectAwardsAward = {
  authority?: Maybe<AwardAuthority>;
  id?: Maybe<Scalars['ID']['output']>;
  rewards?: Maybe<Array<Maybe<ProjectAwardsAwardRewardsReward>>>;
};


export type ProjectAwardsAwardAuthorityArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<AwardAuthorityVariantSelection>>>;
};

export type ProjectAwardsAwardCreateInput = {
  authority?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Array<InputMaybe<ProjectAwardsAwardRewardsRewardCreateInput>>>;
};

export type ProjectAwardsAwardRewardsReward = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type ProjectAwardsAwardRewardsRewardCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectAwardsAwardRewardsRewardUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectAwardsAwardUpdateInput = {
  authority?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Array<InputMaybe<ProjectAwardsAwardRewardsRewardUpdateInput>>>;
};

export type ProjectContentImagesContent = {
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<MediaFile>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProjectContentImagesContentCreateInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectContentImagesContentUpdateInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectContentItemsVideo = {
  id?: Maybe<Scalars['ID']['output']>;
  vimeoID?: Maybe<Scalars['String']['output']>;
  youtubeID?: Maybe<Scalars['String']['output']>;
};

export type ProjectContentItemsVideoCreateInput = {
  vimeoID?: InputMaybe<Scalars['String']['input']>;
  youtubeID?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectContentItemsVideoUpdateInput = {
  vimeoID?: InputMaybe<Scalars['String']['input']>;
  youtubeID?: InputMaybe<Scalars['String']['input']>;
};

/** Input fields necessary to Create a Project */
export type ProjectCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Project.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<ProjectVariantsInput>;
  /** undefined */
  awards?: InputMaybe<Array<InputMaybe<ProjectAwardsAwardCreateInput>>>;
  /** undefined */
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Content of the project, chose from these available elements. */
  content: Array<InputMaybe<Scalars['RepeaterInstance']['input']>>;
  /** undefined */
  credits?: InputMaybe<Array<InputMaybe<ProjectCreditsGroupCreateInput>>>;
  /** undefined */
  date: Scalars['String']['input'];
  /** undefined */
  deliverables?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  excerpt?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  heroImage?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be undefinedvideo/*
   */
  heroVideo?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVideoType?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVimeoVideoID?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroYoutubeVideoID?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  ogImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  platforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  techs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCreditsGroup = {
  company?: Maybe<Company>;
  id?: Maybe<Scalars['ID']['output']>;
  people?: Maybe<Array<Maybe<ProjectCreditsGroupPeopleTeam>>>;
};


export type ProjectCreditsGroupCompanyArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};

export type ProjectCreditsGroupCreateInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Array<InputMaybe<ProjectCreditsGroupPeopleTeamCreateInput>>>;
};

export type ProjectCreditsGroupPeopleTeam = {
  id?: Maybe<Scalars['ID']['output']>;
  members?: Maybe<Array<Maybe<Person>>>;
  role?: Maybe<Scalars['String']['output']>;
};


export type ProjectCreditsGroupPeopleTeamMembersArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PersonVariantSelection>>>;
};

export type ProjectCreditsGroupPeopleTeamCreateInput = {
  members?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCreditsGroupPeopleTeamUpdateInput = {
  members?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCreditsGroupUpdateInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Array<InputMaybe<ProjectCreditsGroupPeopleTeamUpdateInput>>>;
};

/** Possible fields where a filter can be applied to Project. */
export enum ProjectFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Date = 'date',
  Id = 'id'
}

/** Options for filtering Project. */
export type ProjectFilterOptions = {
  field?: InputMaybe<ProjectFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort Project */
export enum ProjectSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Date = 'date',
  Id = 'id'
}

/** Input fields necessary to Update a Project */
export type ProjectUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Project.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<ProjectVariantsInput>;
  /** undefined */
  awards?: InputMaybe<Array<InputMaybe<ProjectAwardsAwardUpdateInput>>>;
  /** undefined */
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Content of the project, chose from these available elements. */
  content?: InputMaybe<Array<InputMaybe<Scalars['RepeaterInstance']['input']>>>;
  /** undefined */
  credits?: InputMaybe<Array<InputMaybe<ProjectCreditsGroupUpdateInput>>>;
  /** undefined */
  date?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  deliverables?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  excerpt?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  heroImage?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be undefinedvideo/*
   */
  heroVideo?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVideoType?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVimeoVideoID?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroYoutubeVideoID?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  ogImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  platforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  techs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for Project */
export type ProjectVariant = {
  /** undefined */
  awards?: Maybe<Array<Maybe<ProjectVariantAwardsAward>>>;
  /** undefined */
  brands?: Maybe<Array<Maybe<Company>>>;
  /** undefined */
  categories?: Maybe<Array<Maybe<WorkCategory>>>;
  /** undefined */
  clients?: Maybe<Array<Maybe<Company>>>;
  /** Content of the project, chose from these available elements. */
  content?: Maybe<Array<Maybe<Scalars['RepeaterInstance']['output']>>>;
  /** undefined */
  credits?: Maybe<Array<Maybe<ProjectVariantCreditsGroup>>>;
  /** undefined */
  date?: Maybe<Scalars['String']['output']>;
  /** undefined */
  deliverables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** undefined */
  excerpt?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  heroImage?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be undefinedvideo/*
   */
  heroVideo?: Maybe<MediaFile>;
  /** undefined */
  heroVideoType?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroVimeoVideoID?: Maybe<Scalars['String']['output']>;
  /** undefined */
  heroYoutubeVideoID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  ogDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  ogImage?: Maybe<MediaFile>;
  /** undefined */
  ogTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  platforms?: Maybe<Array<Maybe<Platform>>>;
  /** undefined */
  techs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  /** undefined */
  url?: Maybe<Scalars['URL']['output']>;
};


/** Definition of a possible variant for Project */
export type ProjectVariantBrandsArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};


/** Definition of a possible variant for Project */
export type ProjectVariantCategoriesArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorkCategoryVariantSelection>>>;
};


/** Definition of a possible variant for Project */
export type ProjectVariantClientsArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};


/** Definition of a possible variant for Project */
export type ProjectVariantContentArgs = {
  referenceContentPassword?: InputMaybe<Scalars['String']['input']>;
  referenceResolutionStrategy?: InputMaybe<RepeaterReferenceResolutionStrategy>;
};


/** Definition of a possible variant for Project */
export type ProjectVariantPlatformsArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PlatformVariantSelection>>>;
};

export type ProjectVariantAwardsAward = {
  authority?: Maybe<AwardAuthority>;
  id?: Maybe<Scalars['ID']['output']>;
  rewards?: Maybe<Array<Maybe<ProjectVariantAwardsAwardRewardsReward>>>;
};


export type ProjectVariantAwardsAwardAuthorityArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<AwardAuthorityVariantSelection>>>;
};

export type ProjectVariantAwardsAwardCreateInput = {
  authority?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Array<InputMaybe<ProjectVariantAwardsAwardRewardsRewardCreateInput>>>;
};

export type ProjectVariantAwardsAwardRewardsReward = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type ProjectVariantAwardsAwardRewardsRewardCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectVariantAwardsAwardRewardsRewardUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectVariantAwardsAwardUpdateInput = {
  authority?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Array<InputMaybe<ProjectVariantAwardsAwardRewardsRewardUpdateInput>>>;
};

export type ProjectVariantContentImagesContent = {
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<MediaFile>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProjectVariantContentImagesContentCreateInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectVariantContentImagesContentUpdateInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectVariantContentItemsVideo = {
  id?: Maybe<Scalars['ID']['output']>;
  vimeoID?: Maybe<Scalars['String']['output']>;
  youtubeID?: Maybe<Scalars['String']['output']>;
};

export type ProjectVariantContentItemsVideoCreateInput = {
  vimeoID?: InputMaybe<Scalars['String']['input']>;
  youtubeID?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectVariantContentItemsVideoUpdateInput = {
  vimeoID?: InputMaybe<Scalars['String']['input']>;
  youtubeID?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectVariantCreditsGroup = {
  company?: Maybe<Company>;
  id?: Maybe<Scalars['ID']['output']>;
  people?: Maybe<Array<Maybe<ProjectVariantCreditsGroupPeopleTeam>>>;
};


export type ProjectVariantCreditsGroupCompanyArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};

export type ProjectVariantCreditsGroupCreateInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Array<InputMaybe<ProjectVariantCreditsGroupPeopleTeamCreateInput>>>;
};

export type ProjectVariantCreditsGroupPeopleTeam = {
  id?: Maybe<Scalars['ID']['output']>;
  members?: Maybe<Array<Maybe<Person>>>;
  role?: Maybe<Scalars['String']['output']>;
};


export type ProjectVariantCreditsGroupPeopleTeamMembersArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PersonVariantSelection>>>;
};

export type ProjectVariantCreditsGroupPeopleTeamCreateInput = {
  members?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectVariantCreditsGroupPeopleTeamUpdateInput = {
  members?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectVariantCreditsGroupUpdateInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Array<InputMaybe<ProjectVariantCreditsGroupPeopleTeamUpdateInput>>>;
};

/** Definition of the input for a possible variant for Project */
export type ProjectVariantInput = {
  /** undefined */
  awards?: InputMaybe<Array<InputMaybe<ProjectVariantAwardsAwardUpdateInput>>>;
  /** undefined */
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Content of the project, chose from these available elements. */
  content?: InputMaybe<Array<InputMaybe<Scalars['RepeaterInstance']['input']>>>;
  /** undefined */
  credits?: InputMaybe<Array<InputMaybe<ProjectVariantCreditsGroupUpdateInput>>>;
  /** undefined */
  date?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  deliverables?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  excerpt?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  heroImage?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be undefinedvideo/*
   */
  heroVideo?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVideoType?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroVimeoVideoID?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  heroYoutubeVideoID?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  ogImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  platforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  techs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for Project.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum ProjectVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for Project with their name as key. */
export type ProjectVariants = {
  /** A variant fr for Project */
  fr?: Maybe<ProjectVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for Project */
  it?: Maybe<ProjectVariant>;
};

/** Input fields necessary to Create or Update a Variants for Project */
export type ProjectVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for Project */
  fr?: InputMaybe<ProjectVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for Project */
  it?: InputMaybe<ProjectVariantInput>;
};

/** Possible ways to request Project in a Get query using the where parameter */
export enum ProjectWhereOptions {
  ModifiedAt = '_modifiedAt',
  Date = 'date'
}

export type ProjectWhereParameter = {
  field?: InputMaybe<ProjectWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of Prototype as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: EDITOR
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type Prototype = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for Prototype.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<PrototypeVariants>;
  /** undefined */
  categories?: Maybe<Array<Maybe<PrototypeCategory>>>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /**
   * undefined
   * Value must be image/*
   */
  image?: Maybe<MediaFile>;
  title: Scalars['String']['output'];
  /** undefined */
  url?: Maybe<Scalars['URL']['output']>;
};


/**
 * Definition of Prototype as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: EDITOR
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type PrototypeCategoriesArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeCategoryVariantSelection>>>;
};

/**
 * Definition of PrototypeCategory as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type PrototypeCategory = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for PrototypeCategory.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<PrototypeCategoryVariants>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /**
   * undefined
   * Value must be >0
   */
  order?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

/** Input fields necessary to Create a PrototypeCategory */
export type PrototypeCategoryCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for PrototypeCategory.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PrototypeCategoryVariantsInput>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be >0
   */
  order?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to PrototypeCategory. */
export enum PrototypeCategoryFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering PrototypeCategory. */
export type PrototypeCategoryFilterOptions = {
  field?: InputMaybe<PrototypeCategoryFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort PrototypeCategory */
export enum PrototypeCategorySortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a PrototypeCategory */
export type PrototypeCategoryUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for PrototypeCategory.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PrototypeCategoryVariantsInput>;
  /**
   * undefined
   *
   * Value must be >0
   */
  order?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for PrototypeCategory */
export type PrototypeCategoryVariant = {
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * undefined
   * Value must be >0
   */
  order?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for PrototypeCategory */
export type PrototypeCategoryVariantInput = {
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * undefined
   *
   * Value must be >0
   */
  order?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for PrototypeCategory.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum PrototypeCategoryVariantSelection {
  Base = 'base'
}

/** All variants for PrototypeCategory with their name as key. */
export type PrototypeCategoryVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for PrototypeCategory */
export type PrototypeCategoryVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request PrototypeCategory in a Get query using the where parameter */
export enum PrototypeCategoryWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type PrototypeCategoryWhereParameter = {
  field?: InputMaybe<PrototypeCategoryWhereOptions>;
  value: Scalars['String']['input'];
};

/** Input fields necessary to Create a Prototype */
export type PrototypeCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Prototype.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PrototypeVariantsInput>;
  /** undefined */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  image?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to Prototype. */
export enum PrototypeFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering Prototype. */
export type PrototypeFilterOptions = {
  field?: InputMaybe<PrototypeFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/**
 * Definition of PrototypePage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type PrototypePage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** The content password */
  _contentPassword?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for PrototypePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<PrototypePageVariants>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  prototypes?: Maybe<Array<Maybe<Prototype>>>;
  title: Scalars['String']['output'];
};


/**
 * Definition of PrototypePage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type PrototypePagePrototypesArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeVariantSelection>>>;
};

/** Input fields necessary to Create a PrototypePage */
export type PrototypePageCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for PrototypePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PrototypePageVariantsInput>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  prototypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to PrototypePage. */
export enum PrototypePageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering PrototypePage. */
export type PrototypePageFilterOptions = {
  field?: InputMaybe<PrototypePageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort PrototypePage */
export enum PrototypePageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a PrototypePage */
export type PrototypePageUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for PrototypePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PrototypePageVariantsInput>;
  /** undefined */
  prototypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for PrototypePage */
export type PrototypePageVariant = {
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  prototypes?: Maybe<Array<Maybe<Prototype>>>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Definition of a possible variant for PrototypePage */
export type PrototypePageVariantPrototypesArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeVariantSelection>>>;
};

/** Definition of the input for a possible variant for PrototypePage */
export type PrototypePageVariantInput = {
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  prototypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for PrototypePage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum PrototypePageVariantSelection {
  Base = 'base'
}

/** All variants for PrototypePage with their name as key. */
export type PrototypePageVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for PrototypePage */
export type PrototypePageVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request PrototypePage in a Get query using the where parameter */
export enum PrototypePageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type PrototypePageWhereParameter = {
  field?: InputMaybe<PrototypePageWhereOptions>;
  value: Scalars['String']['input'];
};

/** Possible ways to sort Prototype */
export enum PrototypeSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a Prototype */
export type PrototypeUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Prototype.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<PrototypeVariantsInput>;
  /** undefined */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  image?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for Prototype */
export type PrototypeVariant = {
  /** undefined */
  categories?: Maybe<Array<Maybe<PrototypeCategory>>>;
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  image?: Maybe<MediaFile>;
  title?: Maybe<Scalars['String']['output']>;
  /** undefined */
  url?: Maybe<Scalars['URL']['output']>;
};


/** Definition of a possible variant for Prototype */
export type PrototypeVariantCategoriesArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeCategoryVariantSelection>>>;
};

/** Definition of the input for a possible variant for Prototype */
export type PrototypeVariantInput = {
  /** undefined */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  image?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for Prototype.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum PrototypeVariantSelection {
  Base = 'base'
}

/** All variants for Prototype with their name as key. */
export type PrototypeVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for Prototype */
export type PrototypeVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request Prototype in a Get query using the where parameter */
export enum PrototypeWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type PrototypeWhereParameter = {
  field?: InputMaybe<PrototypeWhereOptions>;
  value: Scalars['String']['input'];
};

export type Query = {
  /**
   * Gets specified AboutPage using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetAboutPage?: Maybe<AboutPage>;
  /**
   * Gets specified AwardAuthority using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetAwardAuthority?: Maybe<AwardAuthority>;
  /**
   * Gets specified CollabHubPage using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetCollabHubPage?: Maybe<CollabHubPage>;
  /**
   * Gets specified Company using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetCompany?: Maybe<Company>;
  /**
   * Gets specified ContactPage using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetContactPage?: Maybe<ContactPage>;
  /**
   * Gets specified HomePage using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetHomePage?: Maybe<HomePage>;
  /**
   * Gets specified MediaFile using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetMediaFile?: Maybe<MediaFile>;
  /**
   * Gets specified NewsletterPage using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetNewsletterPage?: Maybe<NewsletterPage>;
  /**
   * Gets specified Office using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetOffice?: Maybe<Office>;
  /**
   * Gets specified Person using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetPerson?: Maybe<Person>;
  /**
   * Gets specified Platform using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetPlatform?: Maybe<Platform>;
  /**
   * Gets specified PressArticle using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetPressArticle?: Maybe<PressArticle>;
  /**
   * Gets specified PressPage using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetPressPage?: Maybe<PressPage>;
  /**
   * Gets specified Project using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetProject?: Maybe<Project>;
  /**
   * Gets specified Prototype using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetPrototype?: Maybe<Prototype>;
  /**
   * Gets specified PrototypeCategory using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetPrototypeCategory?: Maybe<PrototypeCategory>;
  /**
   * Gets specified PrototypePage using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetPrototypePage?: Maybe<PrototypePage>;
  /**
   * Gets specified Settings using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetSettings?: Maybe<Settings>;
  /**
   * Gets specified UniversePage using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetUniversePage?: Maybe<UniversePage>;
  /**
   * Gets specified User using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetUser?: Maybe<User>;
  /**
   * Gets specified WorkCategory using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetWorkCategory?: Maybe<WorkCategory>;
  /**
   * Gets specified WorksPage using either slug or id (one of the two arguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetWorksPage?: Maybe<WorksPage>;
  /**
   * Lists all AboutPage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListAboutPage?: Maybe<ListAboutPageResult>;
  /**
   * Lists all AwardAuthority.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListAwardAuthority?: Maybe<ListAwardAuthorityResult>;
  /**
   * Lists all CollabHubPage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListCollabHubPage?: Maybe<ListCollabHubPageResult>;
  /**
   * Lists all Company.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListCompany?: Maybe<ListCompanyResult>;
  /**
   * Lists all ContactPage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListContactPage?: Maybe<ListContactPageResult>;
  /**
   * Lists all HomePage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListHomePage?: Maybe<ListHomePageResult>;
  /**
   * Lists all MediaFile.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListMediaFile?: Maybe<ListMediaFileResult>;
  /**
   * Lists all NewsletterPage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListNewsletterPage?: Maybe<ListNewsletterPageResult>;
  /**
   * Lists all Office.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListOffice?: Maybe<ListOfficeResult>;
  /**
   * Lists all Person.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListPerson?: Maybe<ListPersonResult>;
  /**
   * Lists all Platform.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListPlatform?: Maybe<ListPlatformResult>;
  /**
   * Lists all PressArticle.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListPressArticle?: Maybe<ListPressArticleResult>;
  /**
   * Lists all PressPage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListPressPage?: Maybe<ListPressPageResult>;
  /**
   * Lists all Project.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListProject?: Maybe<ListProjectResult>;
  /**
   * Lists all Prototype.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListPrototype?: Maybe<ListPrototypeResult>;
  /**
   * Lists all PrototypeCategory.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListPrototypeCategory?: Maybe<ListPrototypeCategoryResult>;
  /**
   * Lists all PrototypePage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListPrototypePage?: Maybe<ListPrototypePageResult>;
  /**
   * Lists all Settings.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListSettings?: Maybe<ListSettingsResult>;
  /**
   * Lists all UniversePage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListUniversePage?: Maybe<ListUniversePageResult>;
  /**
   * Lists all User.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListUser?: Maybe<ListUserResult>;
  /**
   * Lists all WorkCategory.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListWorkCategory?: Maybe<ListWorkCategoryResult>;
  /**
   * Lists all WorksPage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListWorksPage?: Maybe<ListWorksPageResult>;
};


export type QueryGetAboutPageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<AboutPageVariantSelection>>>;
  where?: InputMaybe<AboutPageWhereParameter>;
};


export type QueryGetAwardAuthorityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<AwardAuthorityVariantSelection>>>;
  where?: InputMaybe<AwardAuthorityWhereParameter>;
};


export type QueryGetCollabHubPageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CollabHubPageVariantSelection>>>;
  where?: InputMaybe<CollabHubPageWhereParameter>;
};


export type QueryGetCompanyArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
  where?: InputMaybe<CompanyWhereParameter>;
};


export type QueryGetContactPageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ContactPageVariantSelection>>>;
  where?: InputMaybe<ContactPageWhereParameter>;
};


export type QueryGetHomePageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>>>;
  where?: InputMaybe<HomePageWhereParameter>;
};


export type QueryGetMediaFileArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<MediaFileVariantSelection>>>;
  where?: InputMaybe<MediaFileWhereParameter>;
};


export type QueryGetNewsletterPageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<NewsletterPageVariantSelection>>>;
  where?: InputMaybe<NewsletterPageWhereParameter>;
};


export type QueryGetOfficeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<OfficeVariantSelection>>>;
  where?: InputMaybe<OfficeWhereParameter>;
};


export type QueryGetPersonArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PersonVariantSelection>>>;
  where?: InputMaybe<PersonWhereParameter>;
};


export type QueryGetPlatformArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PlatformVariantSelection>>>;
  where?: InputMaybe<PlatformWhereParameter>;
};


export type QueryGetPressArticleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PressArticleVariantSelection>>>;
  where?: InputMaybe<PressArticleWhereParameter>;
};


export type QueryGetPressPageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PressPageVariantSelection>>>;
  where?: InputMaybe<PressPageWhereParameter>;
};


export type QueryGetProjectArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProjectVariantSelection>>>;
  where?: InputMaybe<ProjectWhereParameter>;
};


export type QueryGetPrototypeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeVariantSelection>>>;
  where?: InputMaybe<PrototypeWhereParameter>;
};


export type QueryGetPrototypeCategoryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeCategoryVariantSelection>>>;
  where?: InputMaybe<PrototypeCategoryWhereParameter>;
};


export type QueryGetPrototypePageArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypePageVariantSelection>>>;
  where?: InputMaybe<PrototypePageWhereParameter>;
};


export type QueryGetSettingsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<SettingsVariantSelection>>>;
  where?: InputMaybe<SettingsWhereParameter>;
};


export type QueryGetUniversePageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<UniversePageVariantSelection>>>;
  where?: InputMaybe<UniversePageWhereParameter>;
};


export type QueryGetUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<UserVariantSelection>>>;
  where?: InputMaybe<UserWhereParameter>;
};


export type QueryGetWorkCategoryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorkCategoryVariantSelection>>>;
  where?: InputMaybe<WorkCategoryWhereParameter>;
};


export type QueryGetWorksPageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorksPageVariantSelection>>>;
  where?: InputMaybe<WorksPageWhereParameter>;
};


export type QueryListAboutPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AboutPageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<AboutPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<AboutPageVariantSelection>>>;
};


export type QueryListAwardAuthorityArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AwardAuthorityFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<AwardAuthoritySortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<AwardAuthorityVariantSelection>>>;
};


export type QueryListCollabHubPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CollabHubPageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<CollabHubPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CollabHubPageVariantSelection>>>;
};


export type QueryListCompanyArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<CompanySortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};


export type QueryListContactPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ContactPageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<ContactPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ContactPageVariantSelection>>>;
};


export type QueryListHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<HomePageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<HomePageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>>>;
};


export type QueryListMediaFileArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MediaFileFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<MediaFileSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<MediaFileVariantSelection>>>;
};


export type QueryListNewsletterPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<NewsletterPageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<NewsletterPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<NewsletterPageVariantSelection>>>;
};


export type QueryListOfficeArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OfficeFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<OfficeSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<OfficeVariantSelection>>>;
};


export type QueryListPersonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PersonFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PersonSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PersonVariantSelection>>>;
};


export type QueryListPlatformArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PlatformFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PlatformSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PlatformVariantSelection>>>;
};


export type QueryListPressArticleArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PressArticleFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PressArticleSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PressArticleVariantSelection>>>;
};


export type QueryListPressPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PressPageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PressPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PressPageVariantSelection>>>;
};


export type QueryListProjectArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<ProjectSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProjectVariantSelection>>>;
};


export type QueryListPrototypeArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PrototypeFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PrototypeSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeVariantSelection>>>;
};


export type QueryListPrototypeCategoryArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PrototypeCategoryFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PrototypeCategorySortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeCategoryVariantSelection>>>;
};


export type QueryListPrototypePageArgs = {
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PrototypePageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PrototypePageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypePageVariantSelection>>>;
};


export type QueryListSettingsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SettingsFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<SettingsSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<SettingsVariantSelection>>>;
};


export type QueryListUniversePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UniversePageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<UniversePageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<UniversePageVariantSelection>>>;
};


export type QueryListUserArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<UserSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<UserVariantSelection>>>;
};


export type QueryListWorkCategoryArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<WorkCategoryFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<WorkCategorySortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorkCategoryVariantSelection>>>;
};


export type QueryListWorksPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<WorksPageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<WorksPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorksPageVariantSelection>>>;
};

/** An object containing information about who references this Content and/or how many references it has */
export type Referents = {
  AboutPageReferents?: Maybe<ListAboutPageResult>;
  AwardAuthorityReferents?: Maybe<ListAwardAuthorityResult>;
  CollabHubPageReferents?: Maybe<ListCollabHubPageResult>;
  CompanyReferents?: Maybe<ListCompanyResult>;
  ContactPageReferents?: Maybe<ListContactPageResult>;
  HomePageReferents?: Maybe<ListHomePageResult>;
  MediaFileReferents?: Maybe<ListMediaFileResult>;
  NewsletterPageReferents?: Maybe<ListNewsletterPageResult>;
  OfficeReferents?: Maybe<ListOfficeResult>;
  PersonReferents?: Maybe<ListPersonResult>;
  PlatformReferents?: Maybe<ListPlatformResult>;
  PressArticleReferents?: Maybe<ListPressArticleResult>;
  PressPageReferents?: Maybe<ListPressPageResult>;
  ProjectReferents?: Maybe<ListProjectResult>;
  PrototypeCategoryReferents?: Maybe<ListPrototypeCategoryResult>;
  PrototypePageReferents?: Maybe<ListPrototypePageResult>;
  PrototypeReferents?: Maybe<ListPrototypeResult>;
  SettingsReferents?: Maybe<ListSettingsResult>;
  UniversePageReferents?: Maybe<ListUniversePageResult>;
  UserReferents?: Maybe<ListUserResult>;
  WorkCategoryReferents?: Maybe<ListWorkCategoryResult>;
  WorksPageReferents?: Maybe<ListWorksPageResult>;
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  pointers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsAboutPageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<AboutPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<AboutPageVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsAwardAuthorityReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<AwardAuthoritySortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<AwardAuthorityVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsCollabHubPageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<CollabHubPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CollabHubPageVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsCompanyReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<CompanySortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<CompanyVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsContactPageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<ContactPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ContactPageVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsHomePageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<HomePageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsMediaFileReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<MediaFileSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<MediaFileVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsNewsletterPageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<NewsletterPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<NewsletterPageVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsOfficeReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<OfficeSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<OfficeVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsPersonReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PersonSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PersonVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsPlatformReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PlatformSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PlatformVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsPressArticleReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PressArticleSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PressArticleVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsPressPageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PressPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PressPageVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsProjectReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<ProjectSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProjectVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsPrototypeCategoryReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PrototypeCategorySortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeCategoryVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsPrototypePageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PrototypePageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypePageVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsPrototypeReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<PrototypeSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PrototypeVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsSettingsReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<SettingsSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<SettingsVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsUniversePageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<UniversePageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<UniversePageVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsUserReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<UserSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<UserVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsWorkCategoryReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<WorkCategorySortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorkCategoryVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsWorksPageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<WorksPageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorksPageVariantSelection>>>;
};

export enum RepeaterReferenceResolutionStrategy {
  Complete = 'COMPLETE',
  None = 'NONE',
  Simple = 'SIMPLE'
}

/**
 * Definition of Settings as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type Settings = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for Settings.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<SettingsVariants>;
  /** undefined */
  cookiePolicy?: Maybe<SettingsCookiePolicy>;
  /** undefined */
  externalLinks?: Maybe<Array<Maybe<SettingsExternalLinksLink>>>;
  /** undefined */
  footerTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  genericEmail?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  jobsEmail?: Maybe<Scalars['String']['output']>;
  /** Subscribe */
  newsletterCtaLabel?: Maybe<Scalars['String']['output']>;
  /** undefined */
  newsletterTitle?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  passwordGateGenericBackground?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  passwordGateGenericModel3D?: Maybe<MediaFile>;
  /** undefined */
  passwordGateGenericTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  privacyPolicy?: Maybe<SettingsPrivacyPolicy>;
  /** undefined */
  showreel?: Maybe<SettingsShowreel>;
  /**
   * undefined
   * Value must be video/*
   */
  showreelMobile?: Maybe<MediaFile>;
  /** undefined */
  socialLinks?: Maybe<Array<Maybe<SettingsSocialLinksLink>>>;
  title: Scalars['String']['output'];
};

export type SettingsCookiePolicy = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type SettingsCookiePolicyCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsCookiePolicyUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input fields necessary to Create a Settings */
export type SettingsCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Settings.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<SettingsVariantsInput>;
  /** undefined */
  cookiePolicy?: InputMaybe<SettingsCookiePolicyCreateInput>;
  /** undefined */
  externalLinks?: InputMaybe<Array<InputMaybe<SettingsExternalLinksLinkCreateInput>>>;
  /** undefined */
  footerTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  genericEmail?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  jobsEmail?: InputMaybe<Scalars['String']['input']>;
  /** Subscribe */
  newsletterCtaLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  newsletterTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  passwordGateGenericBackground?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  passwordGateGenericModel3D?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  passwordGateGenericTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  privacyPolicy?: InputMaybe<SettingsPrivacyPolicyCreateInput>;
  /** undefined */
  showreel?: InputMaybe<SettingsShowreelCreateInput>;
  /**
   * undefined
   *
   * Value must be video/*
   */
  showreelMobile?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  socialLinks?: InputMaybe<Array<InputMaybe<SettingsSocialLinksLinkCreateInput>>>;
  title: Scalars['String']['input'];
};

export type SettingsExternalLinksLink = {
  id?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type SettingsExternalLinksLinkCreateInput = {
  label: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SettingsExternalLinksLinkUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to Settings. */
export enum SettingsFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering Settings. */
export type SettingsFilterOptions = {
  field?: InputMaybe<SettingsFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

export type SettingsPrivacyPolicy = {
  file?: Maybe<MediaFile>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type SettingsPrivacyPolicyCreateInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsPrivacyPolicyUpdateInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsShowreel = {
  id?: Maybe<Scalars['ID']['output']>;
  poster?: Maybe<MediaFile>;
  video?: Maybe<MediaFile>;
};

export type SettingsShowreelCreateInput = {
  poster?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsShowreelUpdateInput = {
  poster?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsSocialLinksLink = {
  id?: Maybe<Scalars['ID']['output']>;
  social?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type SettingsSocialLinksLinkCreateInput = {
  social?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsSocialLinksLinkUpdateInput = {
  social?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Possible ways to sort Settings */
export enum SettingsSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a Settings */
export type SettingsUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for Settings.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<SettingsVariantsInput>;
  /** undefined */
  cookiePolicy?: InputMaybe<SettingsCookiePolicyUpdateInput>;
  /** undefined */
  externalLinks?: InputMaybe<Array<InputMaybe<SettingsExternalLinksLinkUpdateInput>>>;
  /** undefined */
  footerTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  genericEmail?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  jobsEmail?: InputMaybe<Scalars['String']['input']>;
  /** Subscribe */
  newsletterCtaLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  newsletterTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  passwordGateGenericBackground?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  passwordGateGenericModel3D?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  passwordGateGenericTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  privacyPolicy?: InputMaybe<SettingsPrivacyPolicyUpdateInput>;
  /** undefined */
  showreel?: InputMaybe<SettingsShowreelUpdateInput>;
  /**
   * undefined
   *
   * Value must be video/*
   */
  showreelMobile?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  socialLinks?: InputMaybe<Array<InputMaybe<SettingsSocialLinksLinkUpdateInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for Settings */
export type SettingsVariant = {
  /** undefined */
  cookiePolicy?: Maybe<SettingsVariantCookiePolicy>;
  /** undefined */
  externalLinks?: Maybe<Array<Maybe<SettingsVariantExternalLinksLink>>>;
  /** undefined */
  footerTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  genericEmail?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  jobsEmail?: Maybe<Scalars['String']['output']>;
  /** Subscribe */
  newsletterCtaLabel?: Maybe<Scalars['String']['output']>;
  /** undefined */
  newsletterTitle?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  passwordGateGenericBackground?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be binary/octet-stream
   */
  passwordGateGenericModel3D?: Maybe<MediaFile>;
  /** undefined */
  passwordGateGenericTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  privacyPolicy?: Maybe<SettingsVariantPrivacyPolicy>;
  /** undefined */
  showreel?: Maybe<SettingsVariantShowreel>;
  /**
   * undefined
   * Value must be video/*
   */
  showreelMobile?: Maybe<MediaFile>;
  /** undefined */
  socialLinks?: Maybe<Array<Maybe<SettingsVariantSocialLinksLink>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SettingsVariantCookiePolicy = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type SettingsVariantCookiePolicyCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsVariantCookiePolicyUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsVariantExternalLinksLink = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type SettingsVariantExternalLinksLinkCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsVariantExternalLinksLinkUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of the input for a possible variant for Settings */
export type SettingsVariantInput = {
  /** undefined */
  cookiePolicy?: InputMaybe<SettingsVariantCookiePolicyUpdateInput>;
  /** undefined */
  externalLinks?: InputMaybe<Array<InputMaybe<SettingsVariantExternalLinksLinkUpdateInput>>>;
  /** undefined */
  footerTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  genericEmail?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  jobsEmail?: InputMaybe<Scalars['String']['input']>;
  /** Subscribe */
  newsletterCtaLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  newsletterTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  passwordGateGenericBackground?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be binary/octet-stream
   */
  passwordGateGenericModel3D?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  passwordGateGenericTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  privacyPolicy?: InputMaybe<SettingsVariantPrivacyPolicyUpdateInput>;
  /** undefined */
  showreel?: InputMaybe<SettingsVariantShowreelUpdateInput>;
  /**
   * undefined
   *
   * Value must be video/*
   */
  showreelMobile?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  socialLinks?: InputMaybe<Array<InputMaybe<SettingsVariantSocialLinksLinkUpdateInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsVariantPrivacyPolicy = {
  file?: Maybe<MediaFile>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type SettingsVariantPrivacyPolicyCreateInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsVariantPrivacyPolicyUpdateInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for Settings.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum SettingsVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

export type SettingsVariantShowreel = {
  id?: Maybe<Scalars['ID']['output']>;
  poster?: Maybe<MediaFile>;
  video?: Maybe<MediaFile>;
};

export type SettingsVariantShowreelCreateInput = {
  poster?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsVariantShowreelUpdateInput = {
  poster?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsVariantSocialLinksLink = {
  id?: Maybe<Scalars['ID']['output']>;
  social?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type SettingsVariantSocialLinksLinkCreateInput = {
  social?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsVariantSocialLinksLinkUpdateInput = {
  social?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** All variants for Settings with their name as key. */
export type SettingsVariants = {
  /** A variant fr for Settings */
  fr?: Maybe<SettingsVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for Settings */
  it?: Maybe<SettingsVariant>;
};

/** Input fields necessary to Create or Update a Variants for Settings */
export type SettingsVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for Settings */
  fr?: InputMaybe<SettingsVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for Settings */
  it?: InputMaybe<SettingsVariantInput>;
};

/** Possible ways to request Settings in a Get query using the where parameter */
export enum SettingsWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type SettingsWhereParameter = {
  field?: InputMaybe<SettingsWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of UniversePage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type UniversePage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for UniversePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<UniversePageVariants>;
  /** undefined */
  contents?: Maybe<Array<Maybe<UniversePageContentsContent>>>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type UniversePageContentsContent = {
  id?: Maybe<Scalars['ID']['output']>;
  info?: Maybe<UniversePageContentsContentInfo>;
  media?: Maybe<MediaFile>;
};

export type UniversePageContentsContentCreateInput = {
  info?: InputMaybe<UniversePageContentsContentInfoCreateInput>;
  media?: InputMaybe<Scalars['String']['input']>;
};

export type UniversePageContentsContentInfo = {
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type UniversePageContentsContentInfoCreateInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UniversePageContentsContentInfoUpdateInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UniversePageContentsContentUpdateInput = {
  info?: InputMaybe<UniversePageContentsContentInfoUpdateInput>;
  media?: InputMaybe<Scalars['String']['input']>;
};

/** Input fields necessary to Create a UniversePage */
export type UniversePageCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for UniversePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<UniversePageVariantsInput>;
  /** undefined */
  contents?: InputMaybe<Array<InputMaybe<UniversePageContentsContentCreateInput>>>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to UniversePage. */
export enum UniversePageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering UniversePage. */
export type UniversePageFilterOptions = {
  field?: InputMaybe<UniversePageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort UniversePage */
export enum UniversePageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a UniversePage */
export type UniversePageUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for UniversePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<UniversePageVariantsInput>;
  /** undefined */
  contents?: InputMaybe<Array<InputMaybe<UniversePageContentsContentUpdateInput>>>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for UniversePage */
export type UniversePageVariant = {
  /** undefined */
  contents?: Maybe<Array<Maybe<UniversePageVariantContentsContent>>>;
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UniversePageVariantContentsContent = {
  id?: Maybe<Scalars['ID']['output']>;
  info?: Maybe<UniversePageVariantContentsContentInfo>;
  media?: Maybe<MediaFile>;
};

export type UniversePageVariantContentsContentCreateInput = {
  info?: InputMaybe<UniversePageVariantContentsContentInfoCreateInput>;
  media?: InputMaybe<Scalars['String']['input']>;
};

export type UniversePageVariantContentsContentInfo = {
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type UniversePageVariantContentsContentInfoCreateInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UniversePageVariantContentsContentInfoUpdateInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UniversePageVariantContentsContentUpdateInput = {
  info?: InputMaybe<UniversePageVariantContentsContentInfoUpdateInput>;
  media?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of the input for a possible variant for UniversePage */
export type UniversePageVariantInput = {
  /** undefined */
  contents?: InputMaybe<Array<InputMaybe<UniversePageVariantContentsContentUpdateInput>>>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for UniversePage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum UniversePageVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for UniversePage with their name as key. */
export type UniversePageVariants = {
  /** A variant fr for UniversePage */
  fr?: Maybe<UniversePageVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for UniversePage */
  it?: Maybe<UniversePageVariant>;
};

/** Input fields necessary to Create or Update a Variants for UniversePage */
export type UniversePageVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for UniversePage */
  fr?: InputMaybe<UniversePageVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for UniversePage */
  it?: InputMaybe<UniversePageVariantInput>;
};

/** Possible ways to request UniversePage in a Get query using the where parameter */
export enum UniversePageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type UniversePageWhereParameter = {
  field?: InputMaybe<UniversePageWhereOptions>;
  value: Scalars['String']['input'];
};

export enum UpdateStrategy {
  Assign = 'ASSIGN',
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

/**
 * Definition of User as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: ADMIN
 * Delete: ADMIN
 * Update: CREATOR
 * Get DRAFT: NOONE
 * Get PUBLISHED: CREATOR
 * List DRAFT: NOONE
 * List PUBLISHED: EDITOR
 * Publish: NOONE
 * Unpublish: NOONE
 */
export type User = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for User.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<UserVariants>;
  disableInvitationEmail?: Maybe<Scalars['Boolean']['output']>;
  /** example@monogrid.com */
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  userStatus?: Maybe<Scalars['String']['output']>;
};

/** Input fields necessary to Create a User */
export type UserCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for User.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<UserVariantsInput>;
  disableInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** example@monogrid.com */
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  userStatus?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to User. */
export enum UserFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering User. */
export type UserFilterOptions = {
  field?: InputMaybe<UserFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort User */
export enum UserSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a User */
export type UserUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for User.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<UserVariantsInput>;
  disableInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** example@monogrid.com */
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userStatus?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for User */
export type UserVariant = {
  disableInvitationEmail?: Maybe<Scalars['Boolean']['output']>;
  /** example@monogrid.com */
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  userStatus?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for User */
export type UserVariantInput = {
  disableInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** example@monogrid.com */
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  userStatus?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for User.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum UserVariantSelection {
  Base = 'base'
}

/** All variants for User with their name as key. */
export type UserVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for User */
export type UserVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request User in a Get query using the where parameter */
export enum UserWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type UserWhereParameter = {
  field?: InputMaybe<UserWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of WorkCategory as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type WorkCategory = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for WorkCategory.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<WorkCategoryVariants>;
  /** undefined */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /**
   * undefined
   * Value must be image/*
   */
  image?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be >0
   */
  order: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

/** Input fields necessary to Create a WorkCategory */
export type WorkCategoryCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for WorkCategory.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<WorkCategoryVariantsInput>;
  /** undefined */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  image?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be >0
   */
  order: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to WorkCategory. */
export enum WorkCategoryFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering WorkCategory. */
export type WorkCategoryFilterOptions = {
  field?: InputMaybe<WorkCategoryFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort WorkCategory */
export enum WorkCategorySortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a WorkCategory */
export type WorkCategoryUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for WorkCategory.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<WorkCategoryVariantsInput>;
  /** undefined */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  image?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be >0
   */
  order?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for WorkCategory */
export type WorkCategoryVariant = {
  /** undefined */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  image?: Maybe<MediaFile>;
  /**
   * undefined
   * Value must be >0
   */
  order?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for WorkCategory */
export type WorkCategoryVariantInput = {
  /** undefined */
  description?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  image?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be >0
   */
  order?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for WorkCategory.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum WorkCategoryVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for WorkCategory with their name as key. */
export type WorkCategoryVariants = {
  /** A variant fr for WorkCategory */
  fr?: Maybe<WorkCategoryVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for WorkCategory */
  it?: Maybe<WorkCategoryVariant>;
};

/** Input fields necessary to Create or Update a Variants for WorkCategory */
export type WorkCategoryVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for WorkCategory */
  fr?: InputMaybe<WorkCategoryVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for WorkCategory */
  it?: InputMaybe<WorkCategoryVariantInput>;
};

/** Possible ways to request WorkCategory in a Get query using the where parameter */
export enum WorkCategoryWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type WorkCategoryWhereParameter = {
  field?: InputMaybe<WorkCategoryWhereOptions>;
  value: Scalars['String']['input'];
};

/**
 * Definition of WorksPage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type WorksPage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for WorksPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<WorksPageVariants>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Input fields necessary to Create a WorksPage */
export type WorksPageCreateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _contentPassword?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for WorksPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<WorksPageVariantsInput>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to WorksPage. */
export enum WorksPageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering WorksPage. */
export type WorksPageFilterOptions = {
  field?: InputMaybe<WorksPageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort WorksPage */
export enum WorksPageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a WorksPage */
export type WorksPageUpdateInput = {
  _author?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional fields variants for WorksPage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: InputMaybe<WorksPageVariantsInput>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for WorksPage */
export type WorksPageVariant = {
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  seoImage?: Maybe<MediaFile>;
  /** undefined */
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for WorksPage */
export type WorksPageVariantInput = {
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  seoImage?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for WorksPage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum WorksPageVariantSelection {
  Base = 'base',
  Fr = 'fr',
  It = 'it'
}

/** All variants for WorksPage with their name as key. */
export type WorksPageVariants = {
  /** A variant fr for WorksPage */
  fr?: Maybe<WorksPageVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for WorksPage */
  it?: Maybe<WorksPageVariant>;
};

/** Input fields necessary to Create or Update a Variants for WorksPage */
export type WorksPageVariantsInput = {
  /** Input fields necessary to Create or Update the variant fr for WorksPage */
  fr?: InputMaybe<WorksPageVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for WorksPage */
  it?: InputMaybe<WorksPageVariantInput>;
};

/** Possible ways to request WorksPage in a Get query using the where parameter */
export enum WorksPageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type WorksPageWhereParameter = {
  field?: InputMaybe<WorksPageWhereOptions>;
  value: Scalars['String']['input'];
};

export type GetAboutPageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getAboutPageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<AboutPageVariantSelection>> | InputMaybe<AboutPageVariantSelection>>;
  where?: InputMaybe<AboutPageWhereParameter>;
  whatWeDoCategoriesStatus2?: InputMaybe<ContentStatus>;
}>;


export type GetAboutPageQuery = { content?: Maybe<(
    Pick<AboutPage, '_slug' | 'id' | 'clientsTitle' | 'heroVideoOverlayLabels' | 'heroTitle' | 'heroPreTitle' | 'pressCtaLabel' | 'pressQuotes' | 'pressTitle' | 'seoDescription' | 'seoTitle' | 'title' | 'whatWeDoDescription' | 'whatWeDoTitle'>
    & { clientsList?: Maybe<Array<Maybe<(
      Pick<Company, 'id' | 'name'>
      & { logo?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>>>, heroBackground?: Maybe<Pick<MediaFile, 'id' | 'metaData' | 'mimeType'>>, heroModel3D?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, seoImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, whatWeDoCategories?: Maybe<Array<Maybe<(
      Pick<WorkCategory, '_slug' | 'id' | 'description' | 'title'>
      & { image?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>>> }
  )> };

export type GetCollabHubPageQueryVariables = Exact<{
  status?: InputMaybe<ContentStatus>;
}>;


export type GetCollabHubPageQuery = { GetCollabHubPage?: Maybe<(
    Pick<CollabHubPage, 'id' | 'formSuccessTitle' | 'formThanksDescription' | 'formThanksTitle' | 'formTitle' | 'seoDescription' | 'seoTitle' | 'title'>
    & { contents?: Maybe<Array<Maybe<(
      { __typename: 'ContentList' }
      & Pick<ContentList, 'id' | 'title'>
      & { list?: Maybe<Array<Maybe<Pick<ContentListItem, 'id' | 'text' | 'title'>>>> }
    ) | (
      { __typename: 'ContentText' }
      & Pick<ContentText, 'id' | 'title' | 'text' | 'layout' | 'author'>
    )>>>, seoImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
  )> };

export type GetContactPageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getContactPageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  where?: InputMaybe<ContactPageWhereParameter>;
  variants?: InputMaybe<Array<InputMaybe<ContactPageVariantSelection>> | InputMaybe<ContactPageVariantSelection>>;
}>;


export type GetContactPageQuery = { content?: Maybe<(
    Pick<ContactPage, 'id' | 'formGeneralTitle' | 'formJobsTitle' | 'formMarketingTitle' | 'formInternationalOpportunitiesTitle' | 'introPreTitle' | 'introTitle' | 'seoDescription' | 'seoTitle' | 'title'>
    & { model3d?: Maybe<Pick<MediaFile, 'id'>>, seoImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
  )> };

export type GetHomePageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getHomePageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>> | InputMaybe<HomePageVariantSelection>>;
  where?: InputMaybe<HomePageWhereParameter>;
}>;


export type GetHomePageQuery = { content?: Maybe<(
    Pick<HomePage, 'aboutUsText1' | 'aboutUsText2' | 'aboutUsText3' | 'aboutUsPreText1' | 'aboutUsPreText2' | 'aboutUsPreText3' | 'aboutUsCtaLabel' | 'featuredWorksTitle' | 'heroVideoOverlayLabels' | 'heroText' | 'id' | 'ourOfficesTitle' | 'seoDescription' | 'seoTitle' | 'title' | 'whatWeDoIntroText' | 'whatWeDoVideoOverlayLabels'>
    & { aboutUsGlb?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, aboutUsBackground?: Maybe<Pick<MediaFile, 'id' | 'metaData' | 'mimeType'>>, featuredWorksList?: Maybe<Array<Maybe<(
      Pick<Project, '_slug' | 'excerpt' | 'id' | 'title'>
      & { categories?: Maybe<Array<Maybe<Pick<WorkCategory, 'id' | 'title'>>>>, heroImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>>>, heroVideo?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, ourOfficesList?: Maybe<Array<Maybe<Pick<Office, 'id' | 'city'>>>>, ourOfficesMedia?: Maybe<Array<Maybe<Pick<MediaFile, 'id' | 'metaData' | 'mimeType'>>>>, seoImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, whatWeDoVideo?: Maybe<Pick<MediaFile, 'id' | 'metaData' | 'mimeType'>>, whatWeDoVideoMobile?: Maybe<Pick<MediaFile, 'id' | 'metaData' | 'mimeType'>> }
  )> };

export type GetNewsletterPageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getNewsletterPageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  where?: InputMaybe<NewsletterPageWhereParameter>;
  variants?: InputMaybe<Array<InputMaybe<NewsletterPageVariantSelection>> | InputMaybe<NewsletterPageVariantSelection>>;
}>;


export type GetNewsletterPageQuery = { content?: Maybe<(
    Pick<NewsletterPage, 'id' | 'description' | 'seoDescription' | 'seoTitle' | 'title'>
    & { model3d?: Maybe<Pick<MediaFile, 'id'>>, seoImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
  )> };

export type GetPersonQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getPersonId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProjectVariantSelection>> | InputMaybe<ProjectVariantSelection>>;
  where?: InputMaybe<PersonWhereParameter>;
  sortOn?: InputMaybe<ProjectSortOptions>;
}>;


export type GetPersonQuery = { content?: Maybe<(
    Pick<Person, 'id' | 'name' | 'employmentType'>
    & { _referents?: Maybe<(
      Pick<Referents, 'id'>
      & { ProjectReferents?: Maybe<(
        Pick<ListProjectResult, 'id'>
        & { items: Array<Maybe<(
          Pick<Project, '_slug' | 'id' | 'date' | 'title'>
          & { brands?: Maybe<Array<Maybe<Pick<Company, 'id' | 'name'>>>>, categories?: Maybe<Array<Maybe<Pick<WorkCategory, '_slug' | 'id' | 'order' | 'title'>>>>, clients?: Maybe<Array<Maybe<Pick<Company, 'id' | 'name'>>>>, heroImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
        )>> }
      )> }
    )> }
  )> };

export type GetPressPageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getPressPageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<PressPageVariantSelection>> | InputMaybe<PressPageVariantSelection>>;
  where?: InputMaybe<PressPageWhereParameter>;
}>;


export type GetPressPageQuery = { content?: Maybe<(
    Pick<PressPage, '_slug' | 'id' | 'seoDescription' | 'seoTitle' | 'title'>
    & { pressKit?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, seoImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
  )> };

export type GetProjectQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getProjectId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectWhereParameter>;
  variants?: InputMaybe<Array<InputMaybe<ProjectVariantSelection>> | InputMaybe<ProjectVariantSelection>>;
}>;


export type GetProjectQuery = { content?: Maybe<(
    Pick<Project, 'content' | 'deliverables' | 'heroYoutubeVideoID' | 'heroVimeoVideoID' | 'heroVideoType' | 'id' | 'ogDescription' | 'ogTitle' | 'techs' | 'url' | '_slug' | 'date' | 'title'>
    & { awards?: Maybe<Array<Maybe<(
      Pick<ProjectAwardsAward, 'id'>
      & { authority?: Maybe<(
        Pick<AwardAuthority, 'id' | 'name' | 'website'>
        & { model?: Maybe<Pick<MediaFile, 'id'>> }
      )>, rewards?: Maybe<Array<Maybe<Pick<ProjectAwardsAwardRewardsReward, 'id' | 'label' | 'url'>>>> }
    )>>>, clients?: Maybe<Array<Maybe<Pick<Company, 'id' | 'name'>>>>, credits?: Maybe<Array<Maybe<(
      Pick<ProjectCreditsGroup, 'id'>
      & { company?: Maybe<Pick<Company, 'id' | 'name' | 'website'>>, people?: Maybe<Array<Maybe<(
        Pick<ProjectCreditsGroupPeopleTeam, 'id' | 'role'>
        & { members?: Maybe<Array<Maybe<Pick<Person, '_slug' | 'name' | 'website' | 'employmentType' | 'id'>>>> }
      )>>> }
    )>>>, heroVideo?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, ogImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, platforms?: Maybe<Array<Maybe<(
      Pick<Platform, 'id' | 'name'>
      & { icon?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>>>, brands?: Maybe<Array<Maybe<Pick<Company, 'id' | 'name'>>>>, categories?: Maybe<Array<Maybe<Pick<WorkCategory, '_slug' | 'id' | 'order' | 'title'>>>>, heroImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
  )> };

export type GetPrototypePageQueryVariables = Exact<{
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
}>;


export type GetPrototypePageQuery = { GetPrototypePage?: Maybe<(
    Pick<PrototypePage, 'id' | 'title'>
    & { prototypes?: Maybe<Array<Maybe<(
      Pick<Prototype, 'url' | 'title' | 'id'>
      & { categories?: Maybe<Array<Maybe<Pick<PrototypeCategory, 'id' | '_slug' | 'order' | 'title'>>>>, image?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>>> }
  )> };

export type GetSettingsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getSettingsId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<SettingsVariantSelection>> | InputMaybe<SettingsVariantSelection>>;
  where?: InputMaybe<SettingsWhereParameter>;
}>;


export type GetSettingsQuery = { content?: Maybe<(
    Pick<Settings, 'footerTitle' | 'genericEmail' | 'id' | 'jobsEmail' | 'newsletterCtaLabel' | 'newsletterTitle' | 'passwordGateGenericTitle' | 'title'>
    & { cookiePolicy?: Maybe<Pick<SettingsCookiePolicy, 'id' | 'label' | 'url'>>, externalLinks?: Maybe<Array<Maybe<Pick<SettingsExternalLinksLink, 'id' | 'label' | 'url'>>>>, passwordGateGenericBackground?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, passwordGateGenericModel3D?: Maybe<Pick<MediaFile, 'id'>>, privacyPolicy?: Maybe<(
      Pick<SettingsPrivacyPolicy, 'id' | 'label'>
      & { file?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>, showreel?: Maybe<(
      Pick<SettingsShowreel, 'id'>
      & { poster?: Maybe<Pick<MediaFile, 'id' | 'metaData' | 'mimeType'>>, video?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>, showreelMobile?: Maybe<Pick<MediaFile, 'id' | 'metaData'>>, socialLinks?: Maybe<Array<Maybe<Pick<SettingsSocialLinksLink, 'id' | 'social' | 'url'>>>> }
  )>, offices?: Maybe<(
    Pick<ListOfficeResult, 'id'>
    & { items: Array<Maybe<Pick<Office, 'id' | 'city' | 'address' | 'country' | 'mail' | 'phone' | 'title'>>> }
  )> };

export type GetUniversePageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getUniversePageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  where?: InputMaybe<UniversePageWhereParameter>;
  variants?: InputMaybe<Array<InputMaybe<UniversePageVariantSelection>> | InputMaybe<UniversePageVariantSelection>>;
}>;


export type GetUniversePageQuery = { content?: Maybe<(
    Pick<UniversePage, 'id' | 'seoDescription' | 'seoTitle' | 'title'>
    & { contents?: Maybe<Array<Maybe<(
      Pick<UniversePageContentsContent, 'id'>
      & { info?: Maybe<Pick<UniversePageContentsContentInfo, 'id' | 'title' | 'url'>>, media?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>>>, seoImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
  )> };

export type GetWorksPageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getWorksPageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<WorksPageVariantSelection>> | InputMaybe<WorksPageVariantSelection>>;
  where?: InputMaybe<WorksPageWhereParameter>;
}>;


export type GetWorksPageQuery = { content?: Maybe<(
    Pick<WorksPage, 'seoDescription' | 'seoTitle' | 'title' | 'id'>
    & { seoImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
  )> };

export type ListPressArticleQueryVariables = Exact<{
  status?: InputMaybe<ContentStatus>;
  sortOn?: InputMaybe<PressArticleSortOptions>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PressArticleFilterOptions>;
  variants?: InputMaybe<Array<InputMaybe<PressArticleVariantSelection>> | InputMaybe<PressArticleVariantSelection>>;
}>;


export type ListPressArticleQuery = { list?: Maybe<(
    Pick<ListPressArticleResult, 'id'>
    & { items: Array<Maybe<(
      Pick<PressArticle, 'date' | 'id' | 'source' | 'title' | 'url'>
      & { image?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>> }
  )> };

export type ListProjectQueryVariables = Exact<{
  status?: InputMaybe<ContentStatus>;
  sortOn?: InputMaybe<ProjectSortOptions>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProjectFilterOptions>;
  contentPassword?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<Array<InputMaybe<ProjectVariantSelection>> | InputMaybe<ProjectVariantSelection>>;
}>;


export type ListProjectQuery = { list?: Maybe<(
    Pick<ListProjectResult, 'id' | 'cursor'>
    & { items: Array<Maybe<(
      Pick<Project, '_slug' | 'id' | 'date' | 'title'>
      & { brands?: Maybe<Array<Maybe<Pick<Company, 'id' | 'name'>>>>, categories?: Maybe<Array<Maybe<Pick<WorkCategory, '_slug' | 'id' | 'order' | 'title'>>>>, clients?: Maybe<Array<Maybe<Pick<Company, 'id' | 'name'>>>>, heroImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
    )>> }
  )> };

export type ProjectFragment = (
  Pick<Project, '_slug' | 'id' | 'date' | 'title'>
  & { brands?: Maybe<Array<Maybe<Pick<Company, 'id' | 'name'>>>>, categories?: Maybe<Array<Maybe<Pick<WorkCategory, '_slug' | 'id' | 'order' | 'title'>>>>, clients?: Maybe<Array<Maybe<Pick<Company, 'id' | 'name'>>>>, heroImage?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
);

export const ProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]} as unknown as DocumentNode;
export const GetAboutPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAboutPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getAboutPageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AboutPageVariantSelection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AboutPageWhereParameter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whatWeDoCategoriesStatus2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetAboutPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getAboutPageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"clientsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroBackground"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroVideoOverlayLabels"}},{"kind":"Field","name":{"kind":"Name","value":"heroTitle"}},{"kind":"Field","name":{"kind":"Name","value":"heroPreTitle"}},{"kind":"Field","name":{"kind":"Name","value":"heroModel3D"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressCtaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"pressQuotes"}},{"kind":"Field","name":{"kind":"Name","value":"pressTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"whatWeDoCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whatWeDoCategoriesStatus2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"whatWeDoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"whatWeDoTitle"}}]}}]}}]} as unknown as DocumentNode;

export function useGetAboutPageQuery(options: Omit<Urql.UseQueryArgs<never, GetAboutPageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAboutPageQuery, GetAboutPageQueryVariables>({ query: GetAboutPageDocument, ...options });
};
export const GetCollabHubPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollabHubPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetCollabHubPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"author"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"list"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formSuccessTitle"}},{"kind":"Field","name":{"kind":"Name","value":"formThanksDescription"}},{"kind":"Field","name":{"kind":"Name","value":"formThanksTitle"}},{"kind":"Field","name":{"kind":"Name","value":"formTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode;

export function useGetCollabHubPageQuery(options: Omit<Urql.UseQueryArgs<never, GetCollabHubPageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCollabHubPageQuery, GetCollabHubPageQueryVariables>({ query: GetCollabHubPageDocument, ...options });
};
export const GetContactPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContactPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getContactPageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactPageWhereParameter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactPageVariantSelection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetContactPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getContactPageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formGeneralTitle"}},{"kind":"Field","name":{"kind":"Name","value":"formJobsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"formMarketingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"formInternationalOpportunitiesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"introPreTitle"}},{"kind":"Field","name":{"kind":"Name","value":"introTitle"}},{"kind":"Field","name":{"kind":"Name","value":"model3d"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode;

export function useGetContactPageQuery(options: Omit<Urql.UseQueryArgs<never, GetContactPageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetContactPageQuery, GetContactPageQueryVariables>({ query: GetContactPageDocument, ...options });
};
export const GetHomePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHomePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getHomePageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HomePageVariantSelection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HomePageWhereParameter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetHomePage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getHomePageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aboutUsText1"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsText2"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsText3"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsPreText1"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsPreText2"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsPreText3"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsCtaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsGlb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsBackground"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featuredWorksTitle"}},{"kind":"Field","name":{"kind":"Name","value":"featuredWorksList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_slug"}},{"kind":"Field","name":{"kind":"Name","value":"excerpt"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroVideoOverlayLabels"}},{"kind":"Field","name":{"kind":"Name","value":"heroVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroText"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ourOfficesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ourOfficesMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ourOfficesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"whatWeDoIntroText"}},{"kind":"Field","name":{"kind":"Name","value":"whatWeDoVideoOverlayLabels"}},{"kind":"Field","name":{"kind":"Name","value":"whatWeDoVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"whatWeDoVideoMobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}}]}}]}}]} as unknown as DocumentNode;

export function useGetHomePageQuery(options: Omit<Urql.UseQueryArgs<never, GetHomePageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetHomePageQuery, GetHomePageQueryVariables>({ query: GetHomePageDocument, ...options });
};
export const GetNewsletterPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNewsletterPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getNewsletterPageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPageWhereParameter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPageVariantSelection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetNewsletterPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getNewsletterPageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"model3d"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode;

export function useGetNewsletterPageQuery(options: Omit<Urql.UseQueryArgs<never, GetNewsletterPageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNewsletterPageQuery, GetNewsletterPageQueryVariables>({ query: GetNewsletterPageDocument, ...options });
};
export const GetPersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getPersonId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectVariantSelection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonWhereParameter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectSortOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetPerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getPersonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"_referents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ProjectReferents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sortOn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Project"}}]}}]}}]}}]}}]}},...ProjectFragmentDoc.definitions]} as unknown as DocumentNode;

export function useGetPersonQuery(options: Omit<Urql.UseQueryArgs<never, GetPersonQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPersonQuery, GetPersonQueryVariables>({ query: GetPersonDocument, ...options });
};
export const GetPressPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPressPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getPressPageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PressPageVariantSelection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PressPageWhereParameter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetPressPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getPressPageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pressKit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode;

export function useGetPressPageQuery(options: Omit<Urql.UseQueryArgs<never, GetPressPageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPressPageQuery, GetPressPageQueryVariables>({ query: GetPressPageDocument, ...options });
};
export const GetProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getProjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectWhereParameter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectVariantSelection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getProjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Project"}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}},{"kind":"Field","name":{"kind":"Name","value":"people"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliverables"}},{"kind":"Field","name":{"kind":"Name","value":"heroYoutubeVideoID"}},{"kind":"Field","name":{"kind":"Name","value":"heroVimeoVideoID"}},{"kind":"Field","name":{"kind":"Name","value":"heroVideoType"}},{"kind":"Field","name":{"kind":"Name","value":"heroVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ogDescription"}},{"kind":"Field","name":{"kind":"Name","value":"ogImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ogTitle"}},{"kind":"Field","name":{"kind":"Name","value":"platforms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"techs"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},...ProjectFragmentDoc.definitions]} as unknown as DocumentNode;

export function useGetProjectQuery(options: Omit<Urql.UseQueryArgs<never, GetProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectQuery, GetProjectQueryVariables>({ query: GetProjectDocument, ...options });
};
export const GetPrototypePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPrototypePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetPrototypePage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contentPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"prototypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"_slug"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

export function useGetPrototypePageQuery(options: Omit<Urql.UseQueryArgs<never, GetPrototypePageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPrototypePageQuery, GetPrototypePageQueryVariables>({ query: GetPrototypePageDocument, ...options });
};
export const GetSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getSettingsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SettingsVariantSelection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SettingsWhereParameter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getSettingsId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cookiePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"footerTitle"}},{"kind":"Field","name":{"kind":"Name","value":"genericEmail"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterCtaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"passwordGateGenericBackground"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passwordGateGenericTitle"}},{"kind":"Field","name":{"kind":"Name","value":"passwordGateGenericModel3D"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"showreel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"poster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"showreelMobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"social"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"offices"},"name":{"kind":"Name","value":"ListOffice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"mail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode;

export function useGetSettingsQuery(options: Omit<Urql.UseQueryArgs<never, GetSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSettingsQuery, GetSettingsQueryVariables>({ query: GetSettingsDocument, ...options });
};
export const GetUniversePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUniversePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getUniversePageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UniversePageWhereParameter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UniversePageVariantSelection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetUniversePage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getUniversePageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode;

export function useGetUniversePageQuery(options: Omit<Urql.UseQueryArgs<never, GetUniversePageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUniversePageQuery, GetUniversePageQueryVariables>({ query: GetUniversePageDocument, ...options });
};
export const GetWorksPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorksPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getWorksPageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorksPageVariantSelection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorksPageWhereParameter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"GetWorksPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getWorksPageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

export function useGetWorksPageQuery(options: Omit<Urql.UseQueryArgs<never, GetWorksPageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWorksPageQuery, GetWorksPageQueryVariables>({ query: GetWorksPageDocument, ...options });
};
export const ListPressArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListPressArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PressArticleSortOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PressArticleFilterOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PressArticleVariantSelection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"list"},"name":{"kind":"Name","value":"ListPressArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode;

export function useListPressArticleQuery(options: Omit<Urql.UseQueryArgs<never, ListPressArticleQueryVariables>, 'query'>) {
  return Urql.useQuery<ListPressArticleQuery, ListPressArticleQueryVariables>({ query: ListPressArticleDocument, ...options });
};
export const ListProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectSortOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectFilterOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectVariantSelection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"list"},"name":{"kind":"Name","value":"ListProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Project"}}]}}]}}]}},...ProjectFragmentDoc.definitions]} as unknown as DocumentNode;

export function useListProjectQuery(options: Omit<Urql.UseQueryArgs<never, ListProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<ListProjectQuery, ListProjectQueryVariables>({ query: ListProjectDocument, ...options });
};